//constant file
import {
  ArrowDown01,
  AlarmClock,
  Album,
  AppWindow,
  Archive,
  ArrowDown,
  ArrowDownAz,
  ArrowDownToLine,
  ArrowDownUp,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowRightLeft,
  ArrowUpDown,
  ArrowUpToLine,
  Award,
  BadgeCheck,
  BadgeQuestionMark,
  Ban,
  Banknote,
  Bell,
  BellDot,
  BellPlus,
  BellRing,
  BetweenHorizontalEnd,
  Bold,
  BookCheck,
  BookOpenText,
  BookText,
  BookUser,
  Bookmark,
  BookmarkCheck,
  BookmarkPlus,
  Bot,
  Box,
  Briefcase,
  Bug,
  Building2,
  Calendar1,
  CalendarCheck,
  CalendarCheck2,
  CalendarDays,
  CalendarPlus,
  CalendarRange,
  CalendarX,
  Camera,
  ChartColumnBig,
  ChartColumnIncreasing,
  ChartLine,
  ChartNoAxesCombined,
  ChartNoAxesGantt,
  ChartPie,
  Check,
  CheckLine,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUp,
  ChevronsUpDown,
  CircleAlert,
  CircleArrowUp,
  CircleCheck,
  CircleCheckBig,
  CircleChevronDown,
  CircleDollarSign,
  CircleEllipsis,
  CircleFadingPlus,
  CircleGauge,
  CircleMinus,
  CircleOff,
  CirclePlus,
  CircleQuestionMark,
  CircleStop,
  CircleUser,
  CircleX,
  CircuitBoard,
  ClipboardCheck,
  ClipboardList,
  ClipboardType,
  ClipboardX,
  Clock4,
  ClockAlert,
  ClockFading,
  ClockPlus,
  CloudCheck,
  CloudDownload,
  CloudSync,
  CloudUpload,
  Columns3,
  Combine,
  Component,
  ContactRound,
  Copy,
  CopyCheck,
  CornerDownRight,
  CreditCard,
  Crosshair,
  Dock,
  Download,
  Ellipsis,
  EllipsisVertical,
  Equal,
  Eye,
  EyeOff,
  File,
  FileChartLine,
  FileCheck,
  FileClock,
  FileDown,
  FileLock,
  FilePen,
  FileQuestionMark,
  FileSearch,
  FileSpreadsheet,
  FileStack,
  FileText,
  FileType2,
  FileUser,
  Flag,
  Folder,
  FolderClock,
  FolderOpenDot,
  FolderOutput,
  Folders,
  Funnel,
  GalleryHorizontalEnd,
  Gift,
  Globe,
  Grid2x2,
  Grip,
  GripVertical,
  Hand,
  Headset,
  History,
  Hourglass,
  House,
  IdCard,
  Image,
  ImagePlus,
  ImageUp,
  Images,
  Inbox,
  IndianRupee,
  Info,
  KeyRound,
  KeySquare,
  Landmark,
  Laptop,
  LaptopMinimalCheck,
  Layers2,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  LifeBuoy,
  Link,
  Link2,
  Link2Off,
  List,
  ListCheck,
  ListChecks,
  ListEnd,
  ListFilter,
  ListIcon,
  ListOrdered,
  ListStart,
  ListTodo,
  Loader,
  LocateFixed,
  Lock,
  LockKeyhole,
  LockKeyholeOpen,
  LogOut,
  Mail,
  MailOpen,
  Mails,
  MapPin,
  Maximize2,
  MessageSquare,
  MessageSquareDiff,
  MessageSquarePlus,
  MessageSquareText,
  MessagesSquare,
  Mic,
  Microchip,
  Minus,
  MonitorCog,
  Moon,
  Move,
  MoveDown,
  MoveDownLeft,
  MoveLeft,
  MoveRight,
  MoveUp,
  MoveUpRight,
  Network,
  NotebookPen,
  NotepadText,
  Octagon,
  OctagonAlert,
  Package,
  PanelTopOpen,
  PanelsLeftBottom,
  Paperclip,
  PenLine,
  Pencil,
  PencilLine,
  Phone,
  PictureInPicture,
  PictureInPicture2,
  Pin,
  PinOff,
  Plane,
  PlaneTakeoff,
  Play,
  Plus,
  Podcast,
  Radar,
  Receipt,
  Redo,
  RedoDot,
  RefreshCcwDot,
  RefreshCw,
  Repeat,
  Reply,
  Rocket,
  RotateCcw,
  Save,
  Scan,
  ScrollText,
  Search,
  SearchCheck,
  SendHorizontal,
  Server,
  Settings,
  Share2,
  ShieldCheck,
  ShieldPlus,
  ShieldUser,
  ShieldX,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  SmilePlus,
  Snowflake,
  Sparkles,
  SquareArrowDown,
  SquareArrowOutUpRight,
  SquareEqual,
  SquareFunction,
  SquareKanban,
  SquarePen,
  SquarePlus,
  SquareUser,
  SquaresExclude,
  Star,
  StickyNote,
  Sun,
  Tag,
  Target,
  ThumbsUp,
  Trash,
  Trash2,
  TrendingUpDown,
  TriangleAlert,
  Trophy,
  Type,
  Undo2,
  Upload,
  User,
  UserCheck,
  UserLock,
  UserMinus,
  UserPen,
  UserPlus,
  UserX,
  Users,
  Vault,
  Volume2,
  WalletCards,
  Webhook,
  Workflow,
  Wrench,
  X,
  Zap
} from "lucide-react";
import "../components/Tasks/tasks.scss";
import { route } from "../config/routes";

//Number Constants
export const number = {
  MINUS_ONE_FIFTY: -150,
  MINUS_FIFTY: -50,
  MINUS_FIFTEEN: -15,
  MINUS_FIVE: -5,
  MINUS_TEN: -10,
  MINUS_TWO: -2,
  MINUS_ONE: -1,
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
  ELEVEN: 11,
  TWELVE: 12,
  THIRTEEN: 13,
  FOURTEEN: 14,
  FIFTEEN: 15,
  SIXTEEN: 16,
  SEVENTEEN: 17,
  EIGHTEEN: 18,
  NINETEEN: 19,
  TWENTY: 20,
  TWENTY_TWO: 22,
  TWENTY_THREE: 23,
  TWENTY_FOUR: 24,
  TWENTY_FIVE: 25,
  TWENTY_SIX: 26,
  TWENTY_SEVEN: 27,
  TWENTY_EIGHT: 28,
  TWENTY_NINE: 29,
  THIRTY: 30,
  THIRTY_ONE: 31,
  THIRTY_THREE: 33,
  THIRTY_FOUR: 34,
  THIRTY_FIVE: 35,
  THIRTY_SIX: 36,
  FORTY: 40,
  FORTY_FIVE: 45,
  FIFTY: 50,
  FIFTY_TWO: 52,
  FIFTY_NINE: 59,
  SIXTY: 60,
  SIXTY_FIVE: 65,
  SEVENTY: 70,
  EIGHTY: 80,
  NINTY: 90,
  NINTY_NINE: 99,
  HUNDRED: 100,
  ONE_HUNDRED_TWENTY: 120,
  ONE_HUNDRED_THIRTY: 130,
  ONE_HUNDRED_FORTY: 140,
  ONE_HUNDRED_FIFTY: 150,
  TWO_HUNDRED: 200,
  TWO_HUNDRED_THIRTY: 230,
  TWO_HUNDRED_THIRTY_FIVE: 235,
  TWO_HUNDRED_FIFTY: 250,
  TWO_HUNDRED_SEVENTY: 270,
  THREE_HUNDRED: 300,
  THREE_HUNDRED_SIXTY_FIVE: 365,
  FOUR_HUNDRED: 400,
  FOUR_HUNDRED_NINTY: 490,
  FIVE_HUNDRED: 500,
  SIX_HUNDRED: 600,
  SIX_HUNDRED_FIFTY: 650,
  FIVE_HUNDRED_EIGHTY: 580,
  SEVEN_HUNDRED: 700,
  THREE_HUNDRED_TWENTY: 320,
  ONE_THOUSAND: 1000,
  ONE_THOUSAND_TWENTY_FOUR: 1024,
  ONE_THOUSAND_FIVE_HUNDRED: 1500,
  FIVE_THOUSAND_ONE: 5001,
  SIX_THOUSAND: 6000,
  SEVEN_THOUSAND: 7000,
  TEN_THOUSAND: 10000,
  ONELAKH_EIGHTY_THOUSAND: 180000,
};

export const limit = {
  WORKFLOW_NAME_MAX_LENGTH: 120,
  WORKFLOW_DESCRIPTION_MAX_LENGTH: 90,
  DASHBOARD_LIMIT: 1073741824,
  TASK_LIMIT: 524288000,
  MAX_FILENAME_LENGTH: 50,
};

// Special Characters

export const specialCharacter = {
  STAR: "*",
  DASH: "-",
  SPACE: " ",
};

//API Request Methods
export const requestMethod = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

// API Request Status
export const requestStatus = {
  OK: 200,
  POST_OK: 201,
  FORBIDDEN: 403,
};

// Type of file sizes
export const fileSizeType = {
  BYTES: "Bytes",
  KILOBYTE: "KB",
  MEGABYTE: "MB",
  GEGABYTE: "GB",
  TERABYTE: "TB",
};

// Labels
export const label = {
  QUICK_ACCESS_ROUTE: "quickAccess",
  FORM_BACKGROUND_COLOR: "Form Background Color",
  PROPERTIES: "Properties",
  PROFILE_CONFIGURATIONS: "Profile Configurations",
  NO_PROJECT_CONFIGURATIONS_DEFINED: "No project configurations are defined for this organization.",
  REVIEW_SECTION: "Review Section",
  REVIEW_SECTION_VISIBLE: "Review section is visible",
  REVIEW_SECTION_HIDDEN: "Review section is hidden",
  RESTORE_VERSION_MSG: "Version restored successfully",
  AUTO_REMOVE: "Auto remove file after upload ",
  SYNCING: "Syncing. Please wait for a moment.",
  UPLOAD_MORE_FILES: "Upload More Files",
  UPLOAD_FILE: "Upload File",
  RESPONSE: "Response",
  CLEAR_FILTER: "Clear Filter",
  SUBMITTED_BY: "Submitted by",
  SWITCH: "Switch",
  YOUR_EMAIL_ADDRESS: "your email address",
  LAST_UPDATED_BY: "Last updated by",
  ON: "on",
  OK: "OK",
  CHIP :"chip",
  EMAIL_DELETED_SUCCESSFULLY: "Email deleted successfully",
  ASSIGNMENT: "Assignment",
  EXPAND_CARDS: "Expand Cards",
  COLLAPSE_CARDS: "Collapse All",
  COLLAPSE_CARD: "Collapse Card",
  EXPAND_CARD: "Expand Card",
  READ_ONLY_DIMENSION: "Read-only dimension on the form (not editable).",
  THIS_IS_THE_ADMIN_CHIP_AND_CANNOT_BE_MODIFIED: "This is the admin chip and cannot be modified.",
  CHIP_NAME: "Chip Name",
  NAME_REQUIRED: "Name is required",
  SHOW: "Show",
  SPACES: "Spaces",
  HIDE: "Hide",
  COPY: "Copy",
  RECONNECT: "Reconnect",
  FIND_IN_MEMBERS: "Find in Members...",
  OFFLINE: "Offline",
  TYPE_TILDE_TO_OPEN: "type ~ to open",
  TYPE_AT_SYMBOL_TO_OPEN: "type @ to open",
  TYPE_HASH_TO_OPEN: "type # to open",
  ASC : "asc",
  BOOKMARKS_AND_CONTENTS: "Bookmarks & Contents",
  NO_CONTENT_FOUND: "Add a bookmark or Paragraph Styles",
  SHEET: "Sheet",
  FINDINPUT_PLACEHOLDER: "Find(⬆⬇ for history)",
  SELECT: "Select",
  LOGIN_PERMISSION: "Log In Permission",
  LOGIN_OPTIONS: "Login Options",
  USER_ID: "User ID",
  SMS_OTP: "SMS (OTP)",
  DRUTAS_EMAIL: "Drutas Email",
  EMAIL_NOTIFICATIONS: "Email Notifications",
  OTP_VERIFICATION: "OTP verification",
  LOGIN_TO_DRUTAS: "Log in to Drutas",
  VERIFICATION_CODE_SENT: "We've sent a verification code to",
  EDIT_PHONE_NUMBER: "Edit phone number",
  RESEND_OTP: "Resend OTP",
  RESEND_OTP_IN: "Resend OTP in",
  LOGGING_IN: "Logging In...",
  LOG_IN: "Log In",
  BACK_TO_LOG_IN: "Back to Log In",
  GOOGLE_SSO: "Google SSO",
  ACTIVATED: "Activated",
  RECURRENCE_PATTERN_AND_MODE: "Recurrence Pattern and Mode",
  MARKED_AS_READ: "Marked as Unread ",
  EMAIL_DELETED_SUCCESSFULLY: "Email moved to Trash",
  EMAILS_DELETED_SUCCESSFULLY: "Emails moved to Trash",
  EMAILS_DELETED_DRAFT: "Draft Deleted",
  INCLUDE_CLEARED_TASK: "Include Cleared Notifications",
  EXPECTED_EFFORT: "Expected Effort",
  AVG_EXPECTED_EFFORT: "Average Expected Efforts (SLA)",
  PER_TASK: "Per task",
  FILTER: "Filter",
  RESET: "Reset",
  TIME_LOGGING: "Time Logging Enabled",
  BILLIABLE: "Billable",
  MAX_LIMIT_EFFORT: "Max Limit is 52 weeks or 365 days",
  MIN_LIMIT_EFFORT: "Minimum Limit is 0",
  SHOW_ALL_NOTIFICATIONS: "Show all",
  RECURRENCE_PATTERN: "Recurrence Pattern",
  SKIP: "Skip",
  TaG_SETTINGS: "Tag Settings",
  DELETE_EMAIL: "Delete Email",
  EMAIL_TASK: "Email Task",
  TAG_NAME: "Tag Name",
  SHOW_MORE_LOGS: "Show More Logs",
  SHOW_LESS_LOGS: "Show Less Logs",
  MORE_LOGS: "More Logs",
  LESS_LOGS: "Less Logs",
  BACKGROUND_COLOUR: "Background Color",
  EDIT_TAG: "Edit Tag",
  TEXT_COLOR: "Text Color",
  TAG_PREVIEW: "Tag Preview",
  TASK_RECURRENCE: "Task Recurrence",
  SKIP: "Skip",
  TASK_ASSIGNEE: "Task Assignee",
  SKIP_PAST_DATES: "Skip Past dates",
  ADD_TAG: "Add Tag",
  DISABLE_RECURRING: "Disable the recurring for the future Tasks",
  FREQUENCY: "Frequency",
  REPEAT_TIMES: "Repeat Times",
  REMINDERS: "Reminders",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  GOOGLE_SSO_SIGN_IN: "Signed in with Google SSO",
  PINNED: "Pinned",
  REMOVE_PIN: "Remove Pin",
  PIN_TASK: "Pin Task",
  TASK_ID: "Task Id",
  BY: "By",
  TASK_NAME: "Task Name Format",
  TASK_ICONS: "Task Icons",
  CONVERT_TASK: "Convert to Task",
  DUE_DATE: "Due Date",
  CHOOSE_PRIORITY: "Priority",
  PRIORITY: "Priority",
  TASK: "Task",
  PRIORITIES: "Priorities",
  CURRENT_USER: "Assignee",
  STAGE: "Stage",
  TAG: "Tag",
  TAGS: "Tags",
  EMAIL: "Email",
  DRAFTS: "(Drafts)",
  DRAFT_CONSTANT: "draft",
  EMAILS: "Emails",
  LIBRARY: "Library",
  FILES_AND_FOLDER: "Files & Folder",
  PASSWORD: "Password",
  PASSWORD_PLACEHOLDER: "Enter your password",
  CURRENT_PASSWORD: "Current Password",
  NEW_PASSWORD: "New Password",
  CONFIRM_PASSWORD: "Confirm Password",
  FULLNAME: "Full Name",
  COMPANY: "Company Name",
  NEW_WIDGET: "Create New Widget",
  BREADCRUMB_TASKS: "Tasks",
  ARCHIVED_TASKS: "Archived Tasks",
  ARCHIVE_TASK: "Archive Task",
  ARCHIVED: "Archived",
  MY_PROJECTS: "My Projects",
  MANAGER_NAME: "Manager",
  JOB_TITLE: "Job Title",
  INBOX: "Inbox",
  WELCOME: "Welcome,",
  HOME: "Home",
  PROJECTS: "Projects",
  QUEUES: "Workspaces",
  ACTIVITY_DIGEST: "Activity Digest",
  CALENDAR: "Calendar",
  HELP_SUPPORT: "Help",
  PROJECT_CODE: "Project Code",
  AI_DRIVEN_INSIGHTS: "AI Insights",
  TEAM_FILTER_PLACEHOLDER: "All Teams",
  STAGE_FILTER_PLACEHOLDER: "All Stages",
  EXTERNAL_TASKS_PROJECT: "External Tasks",
  TEAMS: "Teams",
  DEFAULT_VIEW: "Default View",
  JOB_ROLE: "Job Role",
  ADD_JOB_ROLE: "Add Job Role",
  CC: "CC",
  ADD_CC: "Add CC recipients...",
  CONTACTS: "Contacts",
  SYSTEM_RECIPIENTS: "System Recipients",
  WORK_PROFILE: "Work Profile",
  DEPARTMENT: "Department",
  OFFICE_LOCATION: "Office Location",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  OWNERS: "Project Owners",
  OWNER: "Owner",
  FOLLOWERS: "Followers",
  INVALID_EMAILS: "Invalid Email(s)",
  ERR_MESSAGE: "Some error occured, please try again",
  POSITION: "top-end",
  ERROR_ICON: "error",
  SUCCESS_ICON: "success",
  WARNING_ICON: "warning",
  SHOW_CONFIRM: false,
  SIGNUP_ALERT_FOOTER: '<a href = "http://localhost:3000">Login Instead?</a>',
  PASSWORD_MISMATCH: "The passwords didn't match. Try again.",
  INVALID_USERNAME: "Username is not valid",
  INVALID_TASK_CODE: "Task code is not valid",
  INVALID_MANAGER_NAME: "Manager name is not valid",
  INVALID_JOB_TITLE: "Invalid job title",
  PASSWORD_LENGTH_MISMATCH: "Password must be between 8 to 16 characters",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_MOBILE_NUMBER: "Please enter a valid mobile number",
  ALERT: "Alert!",
  UNLOCK_TASK: "Unlock Task",
  TIME_ERROR: "Start Time should be less than End Time",
  COMPANY_ERROR: "Please enter a valid Company Name",
  OWNER_NAME: "Manager Name",
  STATUS: "Status",
  COMPLETION: "Completion",
  MILESTONES: "Milestones",
  COLLABORATORS: "Collaborators",
  USER: "User",
  ORGANISATION: "Organization",
  PREFERENCES: "Preferences",
  REMOVE_PHOTO: "Remove Photo",
  REMOVE_LOGO: "Remove Logo",
  UPLOAD_LOGO: "Upload Logo",
  UPLOAD_AN_IMAGE: "Upload an Image",
  UPDATE_PROFILE_PHOTO: "Update Profile Photo",
  CHANGE_PROFILE_PICTURE: "Change Profile Photo",
  CHANGE_PASSWORD: "Change Password",
  GOOGLE_USER: "isGoogleUser",
  USERS: "Users",
  EXPORT_CSV: "Export CSV",
  USER_TYPE: "Roles",
  USER_STATUS: "User Status",
  DETAIL_MORE: "More...",
  EXPAND: "Expand",
  COLLAPSE: "Collapse",
  ALL: "All",
  ADMIN: "Admin",
  BILLING_OWNER: "Billing Owner",
  EMPLOYEE: "Employee",
  ACCOUNT_STATUS: "Account Status",
  SHOW_MORE: "Show more",
  SHOW_LESS: "Show less",
  ROLE: "Role",
  LAST_ACTIVITY: "Last Activity",
  ACTIONS: "Actions",
  PROFILE_SETTINGS: "Edit Profile Settings",
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate",
  REACTIVATE: "Reactivate",
  REVOKE: "Revoke",
  APPROVE: "Approve",
  APPROVALS: "Approvals",
  APPROVAL_INITIATED_FILTER: "Approvals Initiated",
  INITIATOR: "Initiator",
  NOTIFICATIONS: "Notifications",
  APPROVAL: "Approval",
  PENDING_APPROVALS: "Pending Approvals",
  ALL_APPROVALS: "Approvals",
  REJECT: "Reject",
  JOIN: "Join",
  JOIN_TEAM: "Join Team",
  REQUEST: "Request",
  ACCEPT: "Accept",
  REQUEST_SENT: "Request Sent!",
  REQUEST_APPROVED: "Request Approved",
  REQUEST_CANCELLED: "Request Cancelled",
  AWAITING_RESPONSE: "Awaiting Response",
  CANCEL_REQUEST: "Cancel Request",
  RETRACT: "Retract",
  INVITE_USERS: "Invite Users",
  ACTIVATE_USERS: "Activate Users",

  DIRECTLY_ACTIVATED_TEXT: "These users will be directly activated",
  ADVANCE: "Advanced Options",
  ACTIVATED_LOGIN_OPTIONS: "Activated Login Options",
  ENTER_EMAILS: "Enter user email(s) , separated by commas",
  NAME_EMAIL_SEARCH: "Search by name or email",
  ORGANIZATION_NAME: "Organization Name",
  SELECT_GROUP_TYPE: "Select Group Type",
  CREATE_GROUPS: "Create Groups",
  USE_FILTERS: "Use Filters",
  STATIC_DESCRIPTION: "Create and manage custom groups manually",
  DYNAMIC_DESCRIPTION: "Use filters to dynamically select users",
  DISPLAYED_INTERNALLY: "(Displayed Internally)",
  REGISTERED_NAME: "Registered Name",
  DOMAIN_REGISTERED_AS: "Domain Registered As",
  TOTAL_SHEATS: "Total Licenses",
  TIME_ZONE: "Time Zone",
  THE: "the",
  USER_SETTINGS: "User Profile Setting",
  USERS_ADDED: "Users Added",
  DEFAULT_PASSWORD: "default",
  DELETE_ORGRANIZATION: "Delete Organization",
  DELETE_STAGE_HEADING: "Delete Stage",
  USER_PROFILE_SETTINGS: "User Profile Settings",
  DELETE_ORGRANIZATION_DESC: "Deleting an Organization is an Irreversible Action. Do you want to Proceed?",
  QUEUE_NAME: "Space Name",
  QUEUE_DESCRIPTION: "Description",
  QUEUE_EMAIL: "Incoming Email",
  QUEUE_PROJECTS: "Default Project",
  QUEUE_OWNERS: "Managers",
  INTERNAL_ERROR: "Internal Server Error",
  ADD_PROJECT_USERS: "Type name, email to add",
  ADD_FILTER: "Add View",
  REMOVE_USER_HEADER: "Remove User",
  ACTION_RESTRICTED: "Action Restricted",
  ASSIGN_NEW_MANAGER_MESSAGE: "Please assign a new Manager before you proceed with leaving the team",
  DELETE_TASK: "Delete Task",
  REMOVE_PROJECT_USER: "Are you sure you want to remove user from this ",
  NUMBER_OF_USERS: "5+ in",
  IN_PROJECT: "in project",
  SELECT_QUEUE: "Select a Workspace",
  CREATED_BY: "By :",
  DEFAULT_PROJECT: "Default Team",
  SEARCH_PROJECTS: "Search Projects",
  ALL_ROLES: "All Roles",
  INVALID_FILE_FORMAT: "Invalid file format. Try again.",
  ACTIVITY_LOG: "Activity Log",
  ACTIVITY_LOGS: "Activity Logs",
  TIME: "Time",
  ACTION: "Action",
  LOG_VIEW: "Log View",
  USER_NAME: "Username",
  DETAILS: "Details",
  DETAILS_SEARCH: "Search Details",
  SHOW: "Show",
  EMAIL_PANEL: "Emails",
  REFRESH: "Refresh",
  PROJECT_NAME: "Project Name",
  ACTIVE: "Active",
  INACTIVE: "In Active",
  INSERTED_SUCCESS: "inserted",
  QUEUE: "Workspace",
  SPACE: "Space",
  DEFAULT: "Filter Columns",
  SEARCH_QUEUES: "Search Workspace",
  ADD_TASK: "Add Task",
  ADD_TEAM: "Add Team",
  ADD_SPAM: "Add Spam",
  ADD_SPAM_EMAIL: "Add Spam Email",
  FROM: "From",
  TO: "To",
  SENDER: "Sender",
  WORKFLOW_EMAIL: "Workflow Email",
  RECEIVER: "Receiver",
  TASKID: "TaskId",
  EMAIL_SUBJECT: "Email Subject",
  SUBJECT: "Subject",
  EMAIL_DETAILS: "Email Details",
  NOT_SPAM: "Not Spam",
  SPAM_LIST: "Spam List",
  ENTER: "Enter",
  EMAIL_ID: "Email Id",
  EMAIL_ERROR_MODAL_TITLE: "Error",
  EMAIL_ERROR_MESSAGE_PREFIX: 'The address "',
  EMAIL_ERROR_MESSAGE_INFIX: '" in the "',
  EMAIL_ERROR_MESSAGE_SUFFIX: '" field was not recognized. Please ensure all addresses are properly formed.',
  DATE_ADDED: "Date Added",
  WORKFLOW_SETTINGS: "Workflow Settings",
  INTERNAL_AUTOMATION_WORKFLOW: "Internal Automation Workflow",
  ADD_SUBTASK: "Add Subtask",
  LINK_TASK: "Link Task",
  SHARE_STREAM: "Share Stream",
  UPDATE_PUBLISH: "Update & Publish",
  SAVE_DRAFT: "Save as Draft",
  SAVE_EDITED_DRAFT: "Save Edited Draft",
  PROJECT: "Project",
  QUEUE_STREAM: "Team Stream",
  SUPERADMIN_STREAM: "SuperAdmin",
  CURRENT_PROJECT: "Assignee",
  CURRENT_QUEUE: "Assignee",
  MARK_COMPLETE: "Mark As Complete",
  MARK_AS_CLOSE: "Mark as Close",
  COMPLETED: "Completed",
  CLOSED: "Closed",
  INCOMPLETE: "Incomplete",
  COMPLETE_FORWARD: "Complete & Forward",
  COMPLETED_RETURNED: "Completed & Returned",
  ATTACHMENTS: "Attachments",
  ATTACHMENT: "Attachment",
  SUB_TASKS: "Sub Tasks",
  LINKED_TAKS: "Linked Tasks",
  LINKED_TASK: "Linked Task",
  LINKED_USERS: "Linked users",
  COMMENTS: "Comments",
  PING: "Ping",
  DEFAULT_USER: "Default User",
  CURRENT_STAGE: "Current Stage",
  CREATOR: "Manager",
  ASSIGN_TO: "Assign To",
  ASSIGNED: "Assigned",
  ASSIGNED_BY: "Assigned By",
  ASSIGNEE: "Assignee",
  ASSIGNEES: "Assignees",
  ASSIGNEE_FILTER_PLACEHOLDER: "All Assignee",
  FOLLOW: "Follow",
  UNFOLLOW: "Unfollow",
  TASK_DESCRIPTION: "Description",
  ASSIGN_TO_ME: "Assign To Me",
  DEFAULT_ASSIGNEE: "Default Assignee",
  DEFAULT_WORKFLOW: "Default ",
  REMOVE_ASSIGNEE: "Remove Assignee",
  COMING_SOON: "Coming soon",
  MAKE_PUBLIC: "Make Public",
  EDITED: "Edited",
  NEW_REPLY: "new",
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  OLDER: "Older",
  PROFILE_PICTURE: "Profile Picture",
  NOTES: "Notes",
  RESTORE: "Restore ",
  DELETE: "Delete ",
  NO: "No",
  YES: "Yes",
  STAGES: "Stages",
  CONFIRM: "Please confirm",
  LOADING: "Loading...",
  REMOVE: "Remove",
  ALTERNATE_TEXT: "Alternate text",
  TITLE: "Title",
  WIDTH: "Width (px)",
  HEIGHT: "Height (px)",
  IMAGE: "Image",
  WEB_ADDRESS: "Web address",
  CANCEL: "Cancel",
  INSERT: "Insert",
  STRING: "string",
  USER_IN_PROJECT: "User is Already in Team",
  REQUESTED_TO_ADMIN: "Request sent to admin",
  ADDED_BY: "Added By",
  USER_HAS_INVITE: "User has pending invite",
  EXIST_IN_DRUTAS: "Email Already Exist in Drutas",
  DATE: "Date",
  STREAM_SAVED: "Stream saved as draft",
  ADD_REM: "Add Reminder",
  CLOSE_POPUP: "Close",
  POP_OUT: "Pop out",
  EDIT_DESC: "Edit Description",
  DEL_REM: "Delete Reminder",
  DEL_REC: "Disable the recurring for the future tasks",
  EDIT_REC: "Edit the current recurring",
  EDIT_REM: "Edit Reminder",
  CONFIRM_TEXT: "Confirm",
  UNDO: "Undo",
  ERROR_OCCURED: "An error occurred, please try again!",
  TASK_PRIORITY: "Task Priority",
  TASK_DUE_DATE: "Set task due date",
  TASK_ARCHIVE_DATE: "Archive done tasks",
  DEFAULT_TAGS: "Default tags",
  DESCRIPTION: "Description",
  DESCRIPTION_TASK: "Task Description",
  INFORMATION: "Quick Info",
  ICON: "Icon",
  PRIVACY: "Privacy",
  EMAIL_FOR_TASK_CREATION: "Email for task Creation",
  STREAM: "Stream",
  JOB_ROLES: "Job Roles",
  GRID: "Grid",
  GRID_VIEW: "Grid View",
  WORKSPACE_CANVAS: "Workspace Canvas",
  WORKSPACE_CONNECT: "Workspace Connect",
  EMAIL_ADDRESS: "Email address",
  EMAIL_PLACEHOLDER: "Enter your email address",
  TEAM_CONNECT: "Team Connect",
  MY_CANVAS: "My Canvas",
  CANVAS: "Canvas",
  ANALYTICS: "Analytics",
  STREAMS: "Streams",
  ADD_STREAM: "Add Stream",
  UPDATE_STREAM: "Update Stream",
  SHARE_WITH: "Share with",
  EDIT_STREAM: "Edit Stream",
  PARENT_TASKS: "Parent tasks",
  CHILD_TASKS: "Child tasks",
  RELATED_TASKS: "Related tasks",
  SUBTASKS: "Sub tasks",
  DAYS: "Days",
  DAY: "Day",
  NOTHING_BOOKMARKED: "No Favorites",
  BOOKMARK_TASKS: "Bookmark Tasks",
  BOOKMARK_PROJECT: "Bookmark Projects",
  BOOKMARK_ICON: "bookmark",
  DELINK_TASK: "Delink Task",
  TASK_CREATED: "task was created",
  APPROVAL_FROM: "Approval From",
  DESCRIPTION_KEY: "description",
  NO_DUE_DATE: "No due date",
  REMOVE_DUE_DATE: "Remove due date",
  SHOW_TASKS_WIHTOUT_DUEDATE: "All Tasks without Due Date",
  VIEW_SETTINGS: "View Settings",
  RENAME_ATTACHMENT: "Rename Attachment...",
  ADD_DUE_DATE: "Add Duedate",
  ADD_NOTE: "Add note...",
  DELETE_POPUP_REF_STREAM: "delete Popup Ref",
  STREAM_POPUP_REF: "stream Popup Ref",
  LOCKED_DESC: "Locked Description",
  VALID_EMAIL: " Email(s) sent successfully",
  DEPENDENCY: "Dependency",
  REMAINING: "remaining",
  ORGANIZATION: "organization",
  SHARE: "Share",
  ORGANIZATION_NAME: "Organisation",
  UPDATE: "Update",
  DEFAULT_STREAM_ALIAS: "Team Drutas",
  MARK_AS_READ: "Mark As Read",
  MARK_ALL_AS_READ: "Mark All As Read",
  NOTIFICATION_TYPE: "Notification Type",
  MARK_AS_SEEN: "Mark As Seen",
  UNREAD: "Unread",
  CHILD_TASK: "Childtask",
  ADD_DELAY: "Add Delay",
  ACTIVE_INACTIVE: "Active/Inactive",
  DAYS_AFTER_COMPLETION: "Days after completion",
  TASK_SETUP: "Task Setup",
  TEAM: "Team",
  TEAM_SELECTION: "team",
  USER_SELECTION: "user",
  WORKFLOW: "Workflow",
  SET_DUE_DATE: "Set Due Date",
  AUTO_SELECT_STAGE: "Auto Select (First Stage)",
  INCOMING_STAGE: "Incoming Stage",
  SKIP_FOR_FORMS: "Skip for Forms",
  SKIP_FOR: "Skip For",
  FORM_TASKS: "Form Tasks",
  NO_TASKS_CREATED: "No Tasks Created",
  TASKS_CREATED: "Tasks Created:",
  DESCRIPTION_TASKS: "Description Tasks",
  DAYS_BEFORE_DUE_DATE: "Days before due date",
  WORKFLOW_DESIGNER: "Workflow Designer",
  BASIC_ELEMENTS: "Basic Elements",
  SIMPLIFIED_DETAILS: "Simplified View",
  DETAILED_TASK_VIEW: "Detailed Task View",
  FLOW_ELEMENTS: "External Flow Elements",
  EXTERNAL_FLOW_LINEAR: "Linear",
  EXTERNAL_FLOW_SMART: "Smart",
  FLOW_ELEMENTS_TOOLTIP_SMART: "Flow Elements (Smart)",
  FLOW_ELEMENTS_TOOLTIP_LINEAR: "Flow Elements (Linear)",
  EXIT_FLOW: "Exit Flow from Orignating Team",
  RETURN_ELEMENTS: "Return Elements",
  DELEGATED_TASK: "Task will return back when completed",
  PASSED_ON_TASK: "Assign to next team/assignee without return",
  TASK_RETURN: "The task will return to the",
  ON_FINAL_COMPLETION: "on final completion",
  NOTE: "Note",
  SELECT_WORKFLOW: "Select Workflow",
  PANEL_VISIBILTY: "Panel Visibility",
  VIEW_CONTROL: "View Control",
  TASK_VIEW: "Task View",
  VIEW_SELECTION: "View Selection",
  DEFAULT_STREAM_ALIAS: "Workspace Drutas",
  SUBTASK: "Subtask",
  LIST_VIEW: "List View",
  BOARD_VIEWS: "Board View",
  KANBAN: "Kanban",
  PIVOT: "Pivot",
  DASHBOARD_VIEW: "DashBoard View",
  COMING_SOON: "Coming soon",
  INACTIVE_WORKFLOW: "Inactive",
  SHOW_ALL_NOTIFICATIONS: "Show all",
  SETTINGS: " Settings",
  SHARE_LINK: "Share Link",
  CLOSE: "Close",
  CLOSE_TASK_PREMATURELY: "Close Task Prematurely?",
  FORCE_CLOSE_TASK: "Force Close Task",
  TASK_TRANSFER_MODE: "Task transfer mode",
  DEFAULT_TEMPLATE: "Default Template",
  MAKE_DEFAULT: "Make Default",
  PROJECT_PRIVACY_CLOSED: "The privacy setting of the project will be changed to closed",
  PROJECT_PRIVACY_SHARED: "The privacy setting of the project will be changed to Shared",
  UNASSIGNED: "Unassigned",
  REMINDER_EXISTS: "Reminder already exists",
  WORKFLOW_DESCRIPTION: "Workflow Description",
  FILTER_NAME_REQUIRED_ERROR: "Filter name is Required",
  FILTER_NAME_DUPLICATE_ERROR: "View Name already exists",
  FAVOURITE_FILTER_LIMIT_REACHED: "Fav limit reached, remove to add",
  DELEGATED: "Delegated",
  OPERATIONAL_TEAM: "Operational Team Name",
  NO_FILTER: "No Filter",
  MY_CANVAS: "My Canvas",
  SELECT_ALL: "Select All",
  OPEN_LINK_IN_NEWTAB: " Open link in new tab",
  ONLY: "Only",
  ITEM: "Item",
  ITEMS: "Items",
  QUEUE_ENTITY: "Queue",
  SORT_ID: "SortId",
  FILTER_NAME_PlACEHOLDER: "Filter Name",
  SELECTED: "Selected",
  INDUSTRY: "Industry",
  CONTACT: "Contact",
  CONTACT_NAME: "Contact Name",
  CONNECT: "Connect",
  CONATACT_NUMBER: "Contact Number",
  REG_NAME_ERROR: "Registered Name Taken",
  REG_NAME_LENGTH_ERROR: "Registered Name must be at least 3 characters long",
  INDUSTRY_NAME_LENGTH_ERROR: "Industry Name must be at least 3 characters long",
  REG_NAME_SPECIAL_CHARACTER_ERROR: "This alphanumeric character is not allowed.",
  OPERATIONAL_TEAM_ERROR: "Should be between 3 and 14 characters only",
  CONTACT_NUMBER_ERROR: "Enter a valid contact number",
  COUNTRY_CODE_ERROR: "Enter a valid country code",
  COMPANY_MAIL_VERIFIED: "Email Verified Sucessfully",
  SHOW_ALL_NOTIFICATIONS: "Show All Notifications",
  CONFIRMATION_SINGLE_EMAIL: "Are you sure you want to delete this email?",
  CONFIRMATION_MULTIPLE_EMAIL: "Are you sure you want to delete these emails?",
  NEW_STREAM_UPDATED: "New Stream is Created",
  ADD: "Add",
  MY: "My ",
  CODE: " Code",
  ADMIN_LABEL: "Admin",
  NAME: " Name",
  DISPLAY_NAME: "Display Name",
  DIRECTORY: "Directory",
  UPLOAD_IMAGE: " Upload an image",
  YOUR_JOB_TITLE: "Your job title",
  YOUR_TASK_CODE: "Your task code (prefix text)",
  YOUR_MANAGER_NAME: "Your manager's name",
  SEARCH: "Search ",
  SEARCH_CRITERIA: "Search Criteria",
  SMALL_S: "s",
  IN: " in",
  RETURN_MODE: "Task Return Mode",
  MODE: "mode",
  DEFINE: "Define ",
  EDIT: "Edit",
  CONFIGURE: "Configure",
  SHOW_DESCRIPTION: "Show",
  HIDE: "Hide",
  COMING_SOON: "Coming Soon",
  DEFAULT: "Default ",
  TASK_DURATION: "Task Duration",
  ALREADY_EXISTS: " already exists",
  REOPEN_TASK: "Reopen Task",
  APPROVAL_CHECK: "Only one approval is allowed per task",
  TASK_ROUTE_AMENDED: "Task Route Amended",
  TASK_AMENDED: "Task Amended",
  SELECT_USER: "Select User",
  PROFILE: "Profile",
  SELECT_WORKSPACE: "Select Workspace",
  DASHBOARD: "Dashboard",
  RECENTLY_VIEWED: "Recently Viewed",
  NOTIFY_ALL: "Notify all the followers in this task",
  ALL: "all",
  SHOW_MORE: "Show more",
  COMPLETED_ARCHIVED: "Task completed & Archived",
  COMPANY: "Company name",
  COLLAB_CENTRAL: "Collab Central",
  HOME: "Home",
  COMPLETED_DATE: "Completed Date",
  TASK_COMPLETED: "Task Completed",
  MORE: "...more",
  WORKFLOWS: "Workflows",
  MEMBERS: "Members",
  WORKSPACE: "Workspace",
  WORKSPACES: "Workspaces",
  ORGANIZATION: "Organization",
  QUICK_LINKS: "Quick Links",
  FOLLOWER_MAIL_INTERVAL: "Follower Mail Interval",
  DELETE_TAG: "Delete tag",
  OWNERSHIP: "Ownership",
  INCLUDE_TASKS: "Include Task(s)",
  INCLUDE: "Include",
  DUE_DATES: "Due Dates",
  DUE_FILTER_OVERDUE: "Overdue",
  TASK_DUE_OPTIONS: "Task Due Options",
  CLEAR: "Clear",
  WORKSPACE_FILTER: "Workspace Filter",
  TEAM_FILTER: "Team Filter",
  MY_FILTER: "My Filter",
  CLEAR_FILTER: "Clear Filter",
  VISIBLE_ONLY_TO_ME: "Visible only for me",
  INITIATED: "Pending",
  INCLUDE_OVERDUE: "Include Overdue",
  NEW_NOTIFICATION: "You've got a new notification!",
  DENIED_REQUEST: "You denied for the notification",
  ACTIVE_PLAN: "Active Plan",
  LICENSE_COUNT: "500 Licenses, Unlimited time",
  LOGIN_TYPE: "Login Type(s)",
  WORK_EMAIL: "Work Email",
  DRUTAS_EMAIL: "Drutas Email",
  USAGE_SUMMARY: "Usage Summary",
  DOWNLOAD_FAILED: "Download failed, Please try again",
  MOVE: "Move",
  SELECT_ALL: "Select All",
  BOARD: "Board",
  S_BOARD: " 's Board",
  TASK_LOCKED: "Task Locked",
  TASK_LOCKED_BY: "Task has been locked by",
  LOCK_TASK: "Lock Task",
  YOU: "you",
  SHOW_ON_BOARD: "Show on board",
  MINIMIZED_VIEW: "Minimized View",
  ACTIVATION: "Activation",
  DEACTIVATION: "Deactivation",
  LOGIN_TYPES: "Login Type(s)",
  TASK_CODE: "Task Code",
  BOARD_NAME: "Board Name",
  PREFIX: "(prefix)",
  EMAIL_MIN: "Min",
  EMAIL_SINGLE: "SINGLE",
  FLAG_EMAIL: "flag",
  TASK_CODE_PLACEHOLDER: "Task code",
  BOARD_NAME_PLACEHOLDER: "Board name",
  REFERENCE: "Reference",
  RESEND_INVITE: "Resend Invite",
  RESET_PASSWORD: "Reset Password",
  USER_PROFILE: "User Profile",
  USER_ENGAGEMENT: "User Engagement",
  MY_BOARD: "My Board",
  USAGE_COUNT: "Usage Count",
  USER_BOARD: "'s Board",
  COMMENT: "Comment",
  PING: "Ping",
  VIEW_COMMENT: "View Comment",
  PAST_DUE_DATES: "Past due dates",
  TOMORROW: "Tomorrow",
  CHOOSE_DATE_TIME: "Choose date & time",
  CHOOSE_DATE: "Choose Date",
  AT: "At",
  DAYS_FROM_TODAY: "Day(s) from today",
  ON_DUE_DATE: "On due date",
  DAYS_BEFORE_DUE_DATE: "Day(s) before due date",
  SET_REMINDER: "Set Reminder",
  CUSTOM: "Custom",
  SET: "Set",
  PEOPLE: "People",
  SMART_CHIPS: "Chips",
  REMINDER_TIME: "Time",
  REMINDER_DATE_AND_TIME: "Reminder Date and Time",
  MODE: "Mode",
  REPEAT_MODE: "Repeat Mode",
  PLAN_MY_DAY: "Plan My Day",
  USE_LIVE_LOCATION: "Use Live Location",
  VIEW_SEEN_REMINDERS: "View Seen Reminders",
  SHOW_SEEN: "Show Seen",
  SHOW_SEEN_REMINDERS: "Show Seen Reminders",
  HIDE_SEEN_REMINDERS: "Hide Seen Reminders",
  DUE: "Due",
  PAST: "Past",
  SAVE: "Save",
  PREVIOUS: "Previous",
  FUTURE: "Future",
  UPCOMING: "Upcoming",
  ACK_EMAIL_BODY: "Email Body",
  DYNAMIC_REMINDER: "Dynamic Reminder",
  VIEW_ALL_NOTIFICATIONS: "View all notifications",
  VIEW_ALL_RECENTLY_VIEWED: "View all recently viewed",
  SHOW_ONLY: "Show Only",
  REMOVE_TEAM: "Remove Team",
  UPLOAD_ORG_LOGO: "Upload your organization logo",
  CREATE_TASK_BY_EMAIL: "Create Task For Each Email Received",
  ACKNOWLEDGEMENT: "Acknowledge All Emails",
  RESET_TO_DEFAULT: "Reset To Default",
  EMAIL_BODY_TEXT: "Email Body Text",
  SEND_TICKET_REF: "Send Task Reference Email",
  TICKET_REFERENCE_EMAIL: "Ticket Reference Email",
  EMAIL_SUBJECT_TEXT: "Email Subject Text",
  RESPONSE_EMAIL_SUBJECT_TEXT: "Reference Email Subject Text",
  ADD_REFERENCE_ID: "Add Reference ID",
  COPY_TO: "Copy to",
  UNIQUE_ID: "Unique ID",
  REF_ID: "Ref ID",
  REFERENCE_ID: "Reference ID",
  CHECK_FOR_SPAM: "Check for spam",
  PAX123: " - PAXC-123",
  REF_ID_TAG: "Ref ID",
  EMAIL_COPIED: "Email Copied",
  CREATE_PASSWORD: "Create Password",
  SEARCH_USER: "Search User...",
  SEARCH_CHIPS: "Search Chips",
  SEARCH_USERS: "Search Users",
  SEARCH_TASKS: "Search Tasks",
  NO_REUSABLE_CHIPS: "No Chips Exist",
  SELECTED_TIME: "Selected Time",
  SELECTED_DATE: "Selected Date",
  CREATED_USING_EMAIL: "Created using email",
  NOTIFICATION_CONTROL: "Notification Control",
  ESC_PRESS: "Press esc to close",
  SEARCH_TASK: "SEARCH TASK",
  POPULAR: "popular",
  RECENTS: "recents",
  VIEW_POPULAR: "View Popular",
  VIEW_RECENT: "View Recent",
  CLASSIC_VIEW: "Classic View",
  MERGE_INTO: "Merge Into",
  POPULAR: "Popular",
  RECENT: "Recent",
  RECENT_TASKS: "Recently Viewed Tasks",
  CLASSIC: "Classic",
  CLASSIC_VIEW: "Classic View",
  COLLAB_CENTRAL_CLASSIC: "Collab Central Classic",
  CLOUD_STORAGE: "Cloud Storage",
  REMEMBER_ME: "Remember Me",
  UNREAD: "Unread",
  TAGGED: "Tagged",
  STREAMS: "Streams",
  USER_PREFERENCE: "userPreference",
  USER_DASHBOARD_DURATION_OPTION: "userDashboardDurationOption",
  DOCUMENTS: "Documents",
  FILES_AND_FOLDER_DOCUMENTS: "Files & Folder",
  DOCUMENTS_ROOT: "documentsRoot",
  VIDEO_PHOTOS: "Videos And Photos",
  ATTACHMENT_RENAMED: "Attachment renamed",
  ATTACHMENT_DELETED: "Attachment deleted",
  DELETE_ATTACHMENT: "Delete Attachment",
  TAKE_TOUR: "Take Quick Tour",
  STEP: "Step",
  AUTOMATION_TASK: "Automation Task",
  BOARD: "Board",
  SIMPLIFIED: "Simplified",
  DESC_POPOUT: "Open description in pop-out mode",
  WF_DESC_POPOUT: "Open in Pop-Out",
  ACKNOWLEDGEMENT_EMAIL: "Acknowledgement Email",
  SCROLL_UP: "Scroll Up [Pg Up]",
  SCROLL_DOWN: "Scroll Down [Pg Dn]",
  TEAM_BREAKDOWN: "Team Breakdown",
  GRAPH: "Insights",
  REPORTING: "Reporting",
  SELECT_DATE: "Select Date",
  SELECT_TIME: "Select Time",
  MY_TASK_CODE: "My Task Code",
  MANAGER: "Manager's Name",
  BOARD_NAME: "Board Name",
  DEFAULT_REMINDER_TIME: "Default Reminder Time",
  DEFAULT_LOCATION: "Indian/Antananarivo",
  CUSTOMIZE_VIEW: "Select Columns",
  VIEW_COLUMNS: "View Columns (Tasks)",
  PIN_POSITION: "Pin Position",
  DATE_RANGE: "Date Range",
  ANYTIME: "Anytime",
  DUE_IN: "Due in",
  TASKS_DUE_IN: "Tasks Due",
  LAST: "Last",
  WIHOUT_DUE_DATE: "Without due date",
  UNASSIGNED_APPROVALS: "Unassigned approvals",
  FOR: "By",
  FILE_NAME: "File Name",
  VALID_FILE: "Please select a valid PDF file.",
  VALID_SIZE_SIZE: "File size must be less than",
  VALID_HEIGHT: "Height must be between 1 and 100%.",
  VALID_WIDTH: "Width must be between 1 and 100%.",
  WIDTH_: "Width",
  SUPER_ADMIN: "superAdmin",
  WELCOME_USER: "Welcome",
  HEIGHT_: "Height",
  URL: "URL",
  TRANSFER_OWNERSHIP: "Transfer Ownership",
  OWNERSHIP_TRANSFERRED: "Ownership Transferred",
  SELECT_FILE: "Please select a file...",
  VISIBILITY_OFF: "Visible only to me",
  RESTRICTED_FILTER: "Restricted Filter",
  VISIBILITY_ON: "Visible to everyone",
  ONE_REQUIRED: "Please select at least one",
  DEFINE_TEAM_STAGES: "Team Stages",
  TEAM_MEMBERS: "Team Members",
  SELECT_ALL_USERS: "Select All Users",
  OTHERS: "Others",
  EXTERNAL_TO_BOARD: "External to Board", 
  FILTER_PIN_POSITION: "Filter pinned to position",
  MAIN_DESCRIPTION: "Main Description",
  APPROVED_DESCRIPTION: "Approved Description",
  EXTERNAL: "External",
  UNBOOKMARK: "Remove Bookmark",
  EXPORT_GRID: "Export Grid",
  EXPORT_AS: "Export As",
  EXPORT: "Export",
  ACCOUNT: "account",
  SELECT_GROUPS: "Select Groups",
  ORGANIZATION_FEATURES_CONTEXT_ERROR: "Use OrganizationFeaturesContext inside OrganizationFeaturesProvider",
  SUPER_ADMIN_CONTEXT_ERROR: "Use SuperAdminContext inside SuperAdminProvider",
  SUPER_ADMIN_CHATBOT_CONTEXT_ERROR: "Use SuperAdminChatBotContext inside SuperAdminChatBotProvider",
  ADMIN_CHATBOT_CONTEXT_ERROR: "Use AdminChatBotContext inside AdminChatBotProvider",
  CFA_CONTEXT_ERROR: "Use CompanyFunctionalAreaContext inside CompanyFunctionalAreaProvider",
  API_INTEGRATION_CONTEXT_ERROR: "Use ApiIntegrationContext inside ApiIntegrationProvider",
  CFA_NAME_MIN_LENGTH: "Value must be min 3 characters",
  CFA_NAME_MAX_LENGTH: "Value should be max 30 characters",
  CFA_REMARK_MAX_LENGTH: "Value should be max 80 characters",
  INVALID_STATUS: "Action Restrcited- This task must remain in it's current status",
  INACTIVATE_WORKFLOW: "Inactivate Workflow",
  DISABLE_WORKFLOW: "Disable Workflow",
  ENABLE_WORKFLOW: "Enable Workflow",
  DISABLE_WORKFLOW_CONFIRMATION: "Are you sure you want to disable Workflow?",
  ENABLE_WORKFLOW_CONFIRMATION: "Are you sure you want to enable Workflow?",
  BOARD_TEAM: " Board",
  INSIGHTS: " Insights",
  EDIT_EXTERNAL_URL: "Edit External Site URL (iFrame)",
  REMARK: "Remark",
  ENABLE_AI_INSIGHTS: "Enable AI Insights",
  AI_DRIVEN_INSIGHTS: "AI Insights",
  CREATOR_NAME: "Creator",
  TASK_DETAILS: "Task Details",
  TIMESHEETS: "Timesheets",
  EMAIL_INTEGRATION: "Email Integration",
  AI_SUMMARY: "AI Summaries",
  FEATURES: "Features",
  UPDATE_WORKFLOW: "Update Workflow",
  INTERNAL_FLOW_ELEMENTS: "Internal Flow Elements",
  HELP_SUPPORTICON: "Chat with Nimba",
  USED: "Used",
  AVAILABLE: "Available",
  AWAY: "Away",
  LAST_UPDATED_AT: "Last updated at",
  PROMPT: "Prompt",
  CHATBOT: "Chatbot",
  CHATBOT_NIMBA: "AI Chatbot (Nimba)",
  AI_INTEGRATIONS: "AI Integration",
  AI: "AI",
  AI_EMAIL: "AI Email",
  MAXIMUM_LIMIT_AND_SIZE_TEN_CHATBOT: "Only 10 files can be uploaded for chatbot sync and training, each with a max size of 10MB",
  MAXIMUM_LIMIT_OF_TEN_CHATBOT: "You have reached the maximum upload limit of 10 files",
  SYNC_TRAIING_CHATBOT: "Upload files (max 10MB each) for chatbot sync and training.",
  ENGAGEMENT: "Engagement",
  BLOCK_ASSIGNMENT: "Block Assignment",
  PROJECT_ALLOCATION: "Project Allocation",
  ALL_PROJECTS: "All Projects",
  WORK_ALLOCATION: "Work Allocation",
  VARIABLES: "Variables",
  FORMS: "Forms",
  VIEWS: "Views",
  FLOW_ELEMENT: "flow elements",
  ALL: "All...",
  CTRL_F: "Ctrl + F",
  NEW_FOLDER: "New Folder",
  VIEW_DETAILS: "View Details",
  CLEAR_LIST: "Clear List",
  NO_FILE_SELECTED: "No File Selected",
  TYPE: "Type",
  SIZE: "Size",
  DATE_AND_CREATED_BY: "Created By and On Date",
  DATE_MODIFIED_AND_CREATED_BY: "Modified By and On Date",
  CREATED_ON_DATE: "Created On Date",
  MODIFIED_ON_DATE: "Modified On Date",
  SAVE_VERSION: "Save Version",
  RESTORE: "Restore",
  CURRENT_VERSION: "Current",
  DESCRIPTION_HISTORY: "Description History",
  ADD_VERSION_MSG: "Version added successfully.",
  VERSION_RESTORED_MSG: "Version restored.",
  UPDATE_VERSION_NAME_MSG: "Version name has been updated.",
  DELETE_VERSION_MSG: "Version deleted successfully.",
  TEAM_NAME: "Team Name",
  AI_EMAIL_LABEL: "AiEmail",
  SUCCESS: "success",
  PENDING: "pending",
  FAILED: "failed",
  LAST_SYNC_AT: "Last sync completed successfully at",
  FILES: "Files",
  DEFAULT_PROMPT_EMAIL: "Default Prompt for AI Insights",
  TYPE_CHATBOT: "chatbot",
  TYPE_EMAIL: "email",
  ROOT: "root",
  FOLDER: "folder",
  MY_LIBRARY: "My Library",
  CMS_GRID: "grid",
  FILE: "file",
  LIST: "list",
  ME: "me",
  EMPTY_TRASH_NOW: "Empty Trash Now",
  DELETE_SPAM: "Delete All Spam Messages Now",
  UPLOAD_FILE: "Upload File",
  ADD_DOX: "Add Dox",
  USER_WORKFLOWS: "User/Workflows",
  UNSAVE: "Save ( Ctrl+S )",
  EXIT_EDIT: "Exit Edit",
  PROJECT_ROOT: "projectRoot",
  VIEW: "View",
  MAKE_A_COPY: "Make a Copy",
  FAVORITE: "Favorite",
  REMOVE_FAVORITE: "Remove Favorite",
  DOWNLOAD: "Download",
  SELECT_ALL: "Select All",
  SELECT: "Select",
  TRASH: "Trash",
  TRASH_FOREVER: "Trash Forever",
  RENAME: "Rename",
  RECENT_ROOT: "recentRoot",
  QUICK_ACCESS_ROOT: "quickAccessRoot",
  TASK_ASSETS_ROOT: "taskAssetsRoot",
  QUICK_ACCESS: "Quick Access",
  VAULT: "My Files Vault",
  TASK_ASSETS: "Task Assets",
  TRASH_ROOT: "trashRoot",
  SHARED_ROOT: "sharedWithMeRoot",
  SHARED_WITH_ME: "Shared with me",
  USER_DIRECTORY: "User Directory",
  BOARD_DIRECTORY: "Directory",
  BOARD_LIBRARY: "Library",
  BOARD_FILES_AND_FOLDER: "Files & Folder",
  TEAM_CANVAS: "Team Canvas",
  MY_RESOURCES: "My Resources",
  MARK_AS_NOT_SPAM: "Mark as Not Spam",
  DOX_MIME_TYPE: "dox",
  DOX_EXT: ".dox",
  DOX_DEFAULT_NAME: "untitled.dox",
  UNTITLED: "untitled",
  INVITE_USER: "Invite User",
  DOX_TASK_KEY: "Dox",
  DOC: "Doc",
  ROUTE_DOX: "docs",
  BUSINESS_UNITS: "Business Units",
  COST_CENTER: "Cost Center",
  DEPARTMENTS: "Departments",
  DELETE_FOREVER: "Delete forever",
  EMAILS: "Emails",
  BUSINESS_UNIT: "Business Unit",
  SMART_CHIP: "smart chip",
  SMART_CHIP_CONSTANT: "Smart",
  FAVORITE_TASKS: "Favorite Task(s)",
  FAVORITE_WORKSPACES: "Favorite Space(s)",
  FAVORITE_FILTERS: "Favorite View(s)",
  FAVOURITE_FILTERS_GRID_TYPE: "FavouriteFilters",
  FAVOURITE_FILTERS_TOOLTIP: "Favorite Views",
  MY_FAVORITES: "Favorites",
  LINKED_TASKS: "Linked Tasks",
  LIBRARY_ROUTE: "library",
  GO_TO: "Go To",
  FORM: "Form",
  SELECT_USER_NAME: "Select User Name",
  WORKFLOW_NAME: "workflow",
  FAVORITE_DOCUMENTS: "Favorite Document(s)",
  EDIT_DESCRIPTION: "Edit Description",
  EMAIL_TEXT: "Email",
  EMAIL_DELETED_FOREVER: "Email Deleted Forever",
  EMAILS_DELETED_FOREVER: "Emails Deleted Forever",
  NO_EMAILS_TO_DELETE: "No emails to delete",
  ADD_API: "Add API",
  GENERATE: "Generate",
  SEARCH_APIS: "Search APIs...",
  API_KEY: "API Key",
  API_DETAILS: "API Details",
  ENABLE: "Enable",
  ENABLED: "Enabled",
  DISABLED: "Disabled",
  REGENERATE: "Regenerate",
  REGENERATING: "Regenerating...",
  GENERAL_INFORMATION: "General Information",
  CREATED_BY: "Created By",
  LAST_USED: "Last Used",
  USAGE_COUNT: "Usage Count",
  API_SERVICES: "API Services",
  ADD_SERVICE: "+ Add Service",
  SELECTED_SERVICES: "Selected Services",
  NO_SERVICES_SELECTED: "No Services Selected",
  LINKED_BY: "Linked By",
  NO_WORKFLOWS_LINKED: "No workflows linked",
  DISABLE: "Disable",
  DISABLED: "Disabled",
  ASSOCIATED_WORKFLOWS: "Associated Workflows",
  API_INTEGRATION: {
    TITLE: "API Integration",
    DESCRIPTION: "Select APIs to enable automation in this workflow",
    ADD_API: "+ Add API",
    INTEGRATED_APIS: "Integrated APIs",
    SEARCH_APIS: "Search APIs...",
    INACTIVE: "Inactive",
    DISABLED_BY_ADMIN: "Disabled by Admin",
    REMOVE_API: "Remove API",
    ADD_API_TOOLTIP: "Add API",
    LOADING_AVAILABLE: "Loading available APIs...",
    NO_APIS_AVAILABLE: "No APIs available to add.",
    LOADING_INTEGRATED: "Loading integrated APIs...",
    NO_APIS_INTEGRATED: "No APIs integrated yet",
    CREATED_BY: "Created by:",
    CALLS: "Calls:",
    LAST_USED: "Last Used:",
    NEVER: "Never",
    CANCEL: "Cancel",
  },
  ENTER_FOLDER_NAME: "Enter the name for the folder",
  INFO: "Info",
  CAP_OWNER: "Owner",
  FILE_TYPE: "File Type",
  CREATED_ON: "Created On",
  LAST_MODIFIED: "Last Modified",
  PATH: "Path",
  LINKED_REFERENCES: "Linked References",
  SWAGGER_LINK: "Swagger Link",
  WORKFLOW_ID: "Workflow Id",
  USER_GROUPS: "User Groups",
  LOADING_GROUPS: "Loading groups...",
  NO_GROUPS_FOUND: "No groups found.",
  MEMBERS: "Members",
  ADD_MEMBERS: "Add Members",
  ADDED_MEMBERS: "Added Members",
  ADD_NEW_GROUP: "Add New Group",
  ADD_NEW_AUDIENCE: "Add New Audience",
  EDIT_GROUP: "Edit Group",
  ALREADY_EXISTS: "Already Exists",
  SORT_BY: "Sort By",
  UNAUTHORIZED_ACCESS: "You are not authorized to edit this card",
  TEAM_CODE: "Team Code",
  USER_REQUEST_TO_ADMIN: "Awaiting Admin approval",
  SETUP_JOB_ROLE: "Job role not updated",
  NEED_TO_SETUP_JOB_ROLE: " needs to set job role",
  LINKED_EMAIL: "Email",
  ALL: "All",
  NONE: "None",
  LINKED_EMAIL: "Linked Email",
  ORGANIZATIONS: "Organizations",
  LOCK: "Lock",
  DRUTAS_AGILE_TASK_MANAGEMENT: "Drutas | Agile Task Management",
  TASK_HISTORY: "Task History",
  TRAINING_FILE_FOR_NIMBA: "Training file for Nimba (Drutas knowledge)",
  WORK_INFOMATION: "Work Information",
  PERSONAL_INFOMATION: "Personal Information",
  LOGIN_SETTINGS: "Login Settings",
  PUSH: "Push",
  GO_TO_FIELD_SETTINGS: "Go to Global Chips",
  GO_TO_JOB_ROLE_SETTINGS: "Go to Time Blocks",
  ADD_JOB_ROLE: "Add Job Role",
  FORM_TYPE: "form",
  OPEN_TASKS: "Open Tasks",
  SEARCH_TEAM: "Search Team",
  ADD_WORKSPACE_OWNER: "Add Space Manager",
  FIND_WORKSPACE: "Find in Space...",
  FIND_IN_USER_DIRECTORY: "Find User ...",
  FIND: "Find...",
  LESS: "less...",
  MORE: "more...",
  EDIT_OWNER: "Edit Owner",
  ADD_FOLLOWERS: "Add Followers",
  REPLY: "Reply",
  SEND_REPLY: "Send Reply",
  TYPE_YOUR_REPLY: "Type your reply...",
  TASK_WORKFLOW_ELEMENT: "Task Workflow Element",
  WORKFLOW_ELEMENT: "Workflow Element",
  USER_PROFILE_LAYOUT: "User Profile Layout",
  PROJECT_PROFILE_LAYOUT: "Project Profile Layout",
  CHIPS: "Chips",
  FIND_IN: "Find in",
  FIND_IN_WORKFLOWS: "Find in Workflows...",
  FIND_IN_REMINDERS: "Find in Reminders...",
  FIND_IN_NOTIFICATIONS: "Find in Notifications...",
  FIND_IN_COMMENTS: "Find in Comments...",
  FIND_IN_FORMS: "Find in Forms...",
  FIND_IN_VIEWS: "Find in Views...",
  FIND_IN_LIBRARY: "Find in Library...",
  FIND_IN_AUTOMATIONS: "Find in Automations...",
  FIND_IN_DOCUMENT: "Find in Document",
  DOCUMENT: "Document",
  EMAIL_SENT_SUCCESSFULLY: "Email sent successfully",
  INVITATION_MAIL_SENT_TO_USER: "Invitation mail sent to user",
  DRAFT_SAVED: "Draft Saved",
  DRAFT_DISCARDED: "Draft Discarded",
  DRAFT_SAVED_SUCCESSFULLY: "Saved successfully",
  EMAIL_SENT_SUCCESSFULLY: "Email sent successfully",
  DRAFT_SAVED: "Draft Saved",
  DRAFT_DISCARDED: "Draft Discarded",
  TASK_LINKED_SUCCESSFULLY: "Task linked successfully",
  ADD_REMINDER_ACTION: "addReminder",
  DELEGATE: "Delegate",
  PASSON: "Pass On",
  REQUEST_APPROVAL: "Request for Approval",
  NO_ORGANIZATION_FOUND: "No organization found for this account",
  ORGANISATION: "Organization",
  SELECT_ORGANIZATION: "Select Organization",
  PHONE_NUMBER: "Phone Number",
  EMAIL_OR_PHONE: "Email/ Phone Number",
  GENERATE_OTP: "Generating OTP...",
  INVALID_OTP: "Invalid OTP",
  CREATED_DATE: "Created Date",
  MY_TEAMS: "My Teams",
  ASSIGNED_TASKS: "Assigned ",
  OVERDUE_TASKS: "Overdue ",
  RECENTLY_CREATED_TASKS: "Recently Created",
  RECENTLY_ACCESSED_WORKFLOW: "Recently Accessed Workflows",
  COMMENTS: "Comments",
  LANDING_PAGE: "Landing Page",
  ESCAPE: "Escape",
  INACTIVE: "inactive",
  TRIGGER: "Trigger",
  DEACTIVATED_LABEL: "Deactivated",
  WORKFLOW_SELECTION: "Workflow Selection",
  WORKFLOWS_AND_FORMS: "Workflows and Forms",
  TRIGGER_INITIATION: "Trigger Initiation",
  ADD_TRIGGER: "Add Trigger",
  ACTIVE_TRIGGERS: "Active Triggers",
  NO_ACTIVE_TRIGGERS: "No Active Triggers",
  TRIGGERS: "Triggers",
  AUDIENCE: "Audience",
  QUICK_INFO: "Quick Info",
  NO_USERS_IN_GROUP: "No users found in this group",
  SHARED_BY_ADMIN_AND_OTHER_USERS: "Shared by Admin & other users",
  MAKE_MY_OWN_LISTS: "Make my own lists",
  FILTERS: "Filters",
  MANAGE_USERS_SET_FILTERS: "Set Filters",
  MANAGE_USERS_APPLIED_FILTERS: "Applied Filters",
  NO_GROUPS_AVAILABLE: "No groups available",
  LOADING_GROUPS: "Loading groups...",
  SELECTED_GROUP: "Selected Group",
  SELECTED_AUDIENCE: "Audience",
  CHANGE_AUDIENCE: "Change Audience",
  ADD_AUDIENCE: "Add audience",
  LOADING_USERS: "Loading users...",
  NO_USERS_AVAILABLE: "No users available. Please try refreshing the page.",
  AUTOMATION_USER_SELECTION: "User Selection",
  STATIC: "Static",
  DYNAMIC: "Dynamic",
  ADVANCED: "Advanced",
  ADD_AUTOMATION: "Add Automation",
  SELECT_USERS: "Select users",
  ADMIN_GROUP: "Created by Admin",
  TEAM_GROUP: "Team Group",
  DYNAMIC_FILTERS: "Dynamic Filters",
  NO_INSTANCES_YET: "No instances yet",
  LOADING_AUTOMATIONS: "Loading automations...",
  FREQUENCY_NOT_CONFIGURED: "Frequency not configured",
  AUTOMATION_DEACTIVATED_HAS_TRIGGERS_INTRO: "This automation is deactivated but has ",
  AUTOMATION_DEACTIVATED_HAS_TRIGGERS_OUTRO: " trigger(s)",
  OWNERSHIP_ALL: "Ownership (All)",
  RECURRENCE_DISABLED: "Recurrence Disabled",
  ADD_TO_HOMESCREEN: "Add Widget to Home",
  FORM_FILTER: "This filter is linked to form",
  NO_MEMBERS_MATCH_THE_CURRENT_CRITERIA: "No members match the current criteria",
  DYNAMIC_LIST_BASED_ON_FILTERS: "Dynamic list based on filters",
  MANUALLY_SELECTED_USER_LIST: "Manually selected user list",
  SELECT_SMART_CHIPS: "View Columns (Chips)",
  AUTOMATION: "Automation",
  AUTOMATIONS: "Automations",
  AUTOMATIONS_AND_SCHEDULES: "Automations & Schedules",
  SCHEDULE: "Schedule",
  AUTOMATION_TRIGGER_CONFIG_TAB: "Config",
  NO_ACTIVE_SCHEDULE: "No Active Schedule",
  SCHEDULES_ACTIVE_STATUS: "Schedule(s) Active",
  AT_LEAST_ONE_SCHEDULE_REQUIRED: "At least one schedule is required",
  ADD_NEW_SCHEDULE: "Add New Schedule",
  MAXIMUM_5_SCHEDULES_ALLOWED: "Maximum 5 schedules allowed",
  ACCESS_RIGHTS: "Access Rights",
  OVERVIEW: "Overview",
  UTC: "UTC",
  SHEETS: "Sheets",
  SELECTED_VARIABLES: "Selected Chips",
  DELETED_VARIABLES: "Deleted Chips",
  USER_PROFILE_CHIPS_GROUP: "User Profile Chips",
  PROJECT_LEVEL_CHIPS: "Project Chips",
  WORKFLOW_NAME: "Workflow Name",
  ALL_AUTOMATIONS: "All Automations",
  REPORTING_HIERARCHY: "Reporting Hierarchy (Manager Chip)",
  NO_MEMBERS: "No members",
  NO_MEMBERS_MATCH_THE_CURRENT_CRITERIA: "No members match the current criteria",
  DEFAULT_GROUP_CANNOT_BE_DELETED: "Default group cannot be deleted",
  REPORTEES: "Reportees",
  DURATION: "Duration",
  EMAILS_ENABLED: "Emails Enabled",
  EMAILS_DISABLED: "Emails Disabled",
  TAGS_AND_FOLLOWERS: "Tags & Followers",
  ATTACHMENTS_AND_LINKED_TASKS: "Attachments & Linked Tasks",
  DISABLE_PANEL_IN_TASK_SIDEBAR: "Disable panel in task sidebar",
  ENABLE_PANEL_IN_TASK_SIDEBAR: "Enable panel in task sidebar",
  HIDE_PANEL: "Hide panel",
  SHOW_PANEL: "Show panel",
  REPORTING_HIERARCHY_LABEL: "Reporting Hierarchy",
  REPORTING_HIERARCHY_CHANGED: "Reporting Hierarchy changed",
  REPORTING_MANAGER_DISABLED_HINT_PREFIX: "Reporting Manager is not enabled. ",
  REPORTING_MANAGER_DISABLED_HINT_LINK: "Click here",
  REPORTING_MANAGER_DISABLED_HINT_SUFFIX: " to enable it.",
  PANEL_NOT_SHOWN_IN_TASK_SIDEBAR: "This feature has been disabled",
  DISABLE_PING: "Disable Ping",
  ENABLE_PING: "Enable Ping",
  DISABLE_PANEL: "Disable",
  ENABLE_PANEL: "Enable",
  DISABLE_PANEL_CONFIRMATION: "Are you sure you want to disable",
  ENABLE_PANEL_CONFIRMATION: "Are you sure you want to enable",
  PANEL: "Panel",
  FORGOT_PASSWORD: "Forgot Password",
  RESET_PASSWORD_MODAL_TITLE: "Reset Password",
  SELECT_RECOVERY_METHOD: "Please select a verified recovery method.",
  SEND_OTP: "Send OTP",
  VERIFY_AND_PROCEED: "Verify & Proceed",
  RESEND_VERIFICATION_CODE: "Resend Verification Code",
  VERIFICATION_CODE_EXPIRES_IN: "Verification code will expire in",
  SECONDS: "seconds",
  DELETE_INSTANCE: "Delete Instance",
  HIDE_SMART_CHIPS: "Hide Chips",
  SHOW_SMART_CHIPS: "Show Chips",
  CONTACT_ADMIN_NOTE: "Don't have access to the above methods? Please contact admin",
  ENTER_VERIFICATION_CODE_SENT_TO: "Enter the verification code sent to",
  ENTER_VERIFICATION_CODE_SENT_TO_BOTH: "Enter the verification code sent to",
  OR: "or",
  TASKS_ASSIGNED: "Tasks Assigned",
  VIEW_WORK_ALLOCATION: "View Work Allocation",
  NO_ACTIVE_TASKS: "No active tasks",
  INPUT: "input",
  API: "API",
  IN_YOUR_PROFILE: "in your profile",
  MY_TEAMS_KEY: "myTeams",
  PROJECT_FILTER_KEY: "projectFilter",
  AUTOMATION_KEY: "automation",
  RECENT_TASKS_KEY: "recentTasks",
  RECENT_WORKFLOWS_KEY: "recentWorkflows",
  RECENT_COMMENTS_KEY: "comments",
  REMINDERS_KEY: "reminders",
  CREATED_TASKS_KEY: "createdTasks",
  ALL_USERS: "All Users",
  MISCELLANEOUS: "Miscellaneous",
  ADD_WIDGET: "Add Widget",
  EXPRESSION_EDITOR_ERROR_IN_EXPRESSION: "Error in expression!",
  EXPRESSION_EDITOR_CLICK_TO_START: "Click to start building expression...",
  EXPRESSION_EDITOR_NO_SMART_CHIPS: "No chips available",
  EXPRESSION_EDITOR_MATHEMATICAL_OPERATORS: "Mathematical Operators",
  EXPRESSION_EDITOR_OPERATORS_DESCRIPTION: "These are used for performing calculations on numbers.",
  EXPRESSION_EDITOR_VALIDATE_AND_SAVE: "Validate & Save",
  SMARTCHIP: "smartChip",
  OPERATOR: "operator",
  TEXT: "text",
  EXPRESSION: "Expression",
  OPERATORS: "Operators",
  SELECT_TO_EXPORT: "Select Section(s) to Export",
  TASK_ESCALATED: "Task Escalated",
  TASK_ESCALATION_ENABLED: "Task Escalation Enabled",
  DYNAMIC_MEMBER: "Dynamic Member",
  MISSING_IDS: "Missing workflow or variable in the URL.",
  NO_VARIABLES: "No variables found for this workflow.",
  VARIABLE_NOT_FOUND: "Variable not found for this workflow.",
  LOAD_FAILED: "Could not load workflow variables.",
  LOAD_FAILED_NOTIFICATION: "Could not load workflow variables.",
  BACK_HOME: "Home",
  UNASSIGNED_GROUP: "unassigned",
  SELECTED_COLUMNS: "Selected Columns",
  GROUP_FIELD: "columnPickerGroup",
  NO: "No",
  DELETE_GROUP: "Delete Group",
  USED_IN_AUTOMATION: "Group in use",
  NO_ALLOCATIONS: "No allocations",
  ALLOCATION: "Allocation",
  NIL: "Nil",
  NAME_FORMAT_LABEL: "Name Format",
  EDIT_INFO: "Edit Info",
  DYNAMIC_USER_GROUP: "Dynamic User Group",
};

// Quotes and Messages
export const quote = {
  TEMPLATE_UPLOAD_FAIL: "Failed to upload template",
  TEMPLATE_UPLOAD_SUCCESS: "Template uploaded successfully",
  TEMPLATE_DOWNLOAD_SUCCESS: "Template downloaded successfully",
  TEMPLATE_DOWNLOAD_FAIL: "Failed to download template",
  TASK_ID_MISSING: "TaskId is missing",
  TAG_ADDED_SUCCESSFULLY: "Tag added successfully",
  UNUSED_CHIP_INFO: "Add chip in the Form to enable properties ",
  FAILED_TO_UPDATE_FIRST_NODE_STATUS: "Failed to update first node status",
  STARTER_CONNECTION_REMOVED: "Starter connection removed",
  COMPLETED_AND_FORWARDED: "Completed & Forwarded ",
  DRUTAS_EMAIL_VALIDATION: "Please wait for Drutas email verification to complete",
  NODE_DELETED_SUCCESSFULLY: "Node deleted successfully",
  WORKFLOW_ID_MISSING: "WorkflowId is missing",
  INVALID_TASK: "Invalid task",
  INVALID_WORKFLOW: "Invalid workflow",
  FAILED_TO_DELETE_NODE: "Failed to delete node. Please try again.",
  ERROR_DELETING_NODE: "Error deleting node: ",
  DEFAULT_PROMPT_EMAIL_SUMMARY_UPDATED: "Default Prompt for AI Insights Updated",
  IMG_HEADER:
    "“Collaboration is the best way to work. It's only way to work, really. Everyone's there because they have a set of skills to offer across the board.",
  FORM_HEADER: "Work Smart, Deliver Fast!",
  ADDED_TO_FAV: "Added to Favorite successfuly",
  REMOVED_FROM_FAV: "Removed from favorites ",
  EMAIL_RESTORED: "Email Restored Successfully",
  EMAIL_MARKED_AS_READ: "Email Marked as Read Successfully",
  FOREVER_DELETE: "Email Deleted Forever",
  EMAIL_NOT_SPAM: "Email Marked as Not spam",
  TRASH_EMPTY: "Messages in trash for more than 30 days will be automatically deleted",
  AI_NOTE: "Use AI to extract key intent and actions from task and tickets",
  APPLICABLE_TASK: "Applicable for tasks created by",
  SPAM_EMPTY: "Messages that have been in spam for more than 30 days will be automatically deleted",
  PLEASE_ADD_DETAILS: "Please Add Details",
  FORM_ADMIN_USER: "Create your organization profile",
  FORM_USER_PROFILE: "Set up your user profile",
  FORM_USER_WELCOME: "Provide your details to set up your profile",
  FORM_QUOTE: "Set you password to login",
  NEW_ACC: "Don't have an account?",
  DOWNLOAD_APP: "Download the mobile app",
  OPTION: "Or",
  SPAM_ALREADY_EXISTS: "Spam Already exists",
  CREATE_ACC: "Sign up",
  FORGOTPASS_LINK: "Forgot your password?",
  LOGIN_FORM_FOOTER1: "The future of mobile is the future of everything",
  LOGIN_FORM_FOOTER2: "Now download the latest Drutas Management tool on your smart phones",
  COPYRIGHT: `Copyright © ${new Date().getFullYear()} All Rights Reserved with`,
  COMPANY: "Paxcom",
  COUNTRY: "India",
  SIGNUP_HEADER: "Sign up",
  TAG_ALREADY_EXITS: "Tag Already Exists",
  NO_ACCESS: "You do not have access to the task",
  TAG_DELETED: "Tag deleted successfully",
  SIGNUP_WELCOME: "Sign up to continue",
  EXISTING_ACC: "Already have an account? ",
  SIGNIN_INSTEAD: "Log In",
  FAILED_TO_AUTOMATICALLY_VERIFY_OTP: "Failed to automatically verify OTP. Please enter the OTP manually.",
  FORGOTPASSWORD_HEADER: "Forgot your password?",
  LOGIN_HEADER: "Log in to Drutas",
  LEFTBANNER_LOGO_QUOTE: "Simplify work management",
  LEFTBANNER_JOIN: "Join",
  LEFTBANNER_DRUTAS: "Drutas",
  LEFTBANNER_MAINHEADING: "and unlock Seamless team collaboration.",
  LEFTBANNER_SUBHEADING: "Effortlessly set up and customize workflows for any project, making teamwork more efficient and productive.",
  LOGIN_WELCOME: "Please log in to get started",
  LOGIN_TO_ANOTHER_ORG_LINK: "Login to another organization",
  FORGOTPASSWORD_WELCOME: "Enter your email to get reset instructions.",
  FORGOTPASSWORD_FOOTER: " Make sure to check your spam filter for an email from info@paxcom.net",
  BACKTOLOGIN: "Back to Log In",
  HEADER_MENU_FEATURES: "Features",
  HEADER_MENU_INGEGRATONS: "Integrations",
  HEADER_MENU_WHATSNEW: "What's New",
  HEADER_MENU_ABOUTSUS: "About us",
  HEADER_MENU_SUPPORT: "Support",
  PASSWORD_CHARACTER_SET: "Password must be between 8 to 16 characters",
  HEADER: "New Project",
  SUBHEADER: "This contains basic information about your project",
  ADD_QUEUE_HEADER: "Add New Workspace",
  EXISTING_QUEUE: "Workspace Details",
  AI_NOTE: "Use AI to extract key intent and actions from task and tickets",
  AI_INSIGHTS_ADMIN_ONLY: "Your organization administrator must enable AI Insights before you can configure these options.",
  APPLICABLE_TASK: "Applicable for tasks created by ",
  MOVE_EXISTING_PROJECT: "Projects",
  ADD_PROJECT: "Add Project",
  EDIT_PROJECT: "Edit Project",
  TEAM: "Members",
  MOVE_TO: "Move To",
  REQUIRED_FIELD: "This is a Required Field",
  EMAIL_NOT_MATCHED: "This Email Is Not Provisioned For Access!",
  GOOGLE_SSO_EMAIL_NOT_MATCHED: "This email is not authorized for access",
  REQUIRED_OWNERS: "Please Select Atleast One Manager",
  RETURNABLE_TASK: "Delegate",
  NON_RETURNABLE_TASK: "Pass On",
  ENTER_TASK_NAME_PROJECT: "Please enter a task name and project!",
  EXTERNAL_TASK: "The task will move to the personal Team of the user",
  PROJECT_MOVE_FROM_PRIMARY: "Move Team To Secondary List",
  PROJECT_MOVE_FROM_SECONDARY: "Move Team To Primary List",
  QUEUE_MOVE_FROM_PRIMARY: "Move Workspace To Secondary List",
  QUEUE_MOVE_FROM_SECONDARY: "Move Workspace To Primary List",
  UNDER_CONSTRUTION: "Our home page is under construction",
  DELEGATE_TASK: "Return to original project, On completion",
  PASS_ON_TASK: "Move to assigned project (Non returnable task)",
  ON_TOOLTIP_DELEGATE_TASK: "Task delegated to",
  ON_TOOLTIP_PASS_ON_TASK: "Task has been passed on from",
  TOOLTIP_PASS_ON_TASK: "Task is passed on from",
  TOOLTIP_DELEGATE_TASK: "and delegated to",
  ON_TOOLTIP_RETURNABLE_TASK: "Task will return to ",
  ON_COMPLETION: ", On completion",
  VERSION: "v ",
  REPLYING_TO: "replying to",
  DELETED_COMMENT: "This comment was deleted",
  PROJECT_ACCESS_DENIED: "You do not have access to this Team!",
  WORKFLOW_ACCESS_DENIED: "You do not have access to this Workflow!",
  TASK_ACCESS_DENIED: "You do not have access to this Task!",
  ACCESS_DENIED: "Access Denied",
  WORKSPACE_ACCESS_DENIED: "You donot have access to this Workspace!",
  MANAGE_WORKFLOW: "Manage Project Workflow",
  EMPTY_NOTES: "Click + icon to create new Note",
  NEW_NOTE: "Add New Note!",
  LAST_SAVE: "Last saved at",
  STAGE_NAME_ERROR: "Stage name is required",
  NAME_EXIST: "Stage name already exists",
  MIN_STAGE_ERROR: "A minimum of two stages required!",
  CANNOT_DELETE_STAGE: "This stage cannot be deleted!",
  DELETE_NOTE: "Are you sure you want to delete this note?",
  AUTOMATION_DELETE_CONFIRMATION:
    "Are you sure you want to delete this automation? This action cannot be undone.",
  DELETE_STAGE:
    "The stage you want to delete has open tasks. Are you sure you want to delete this stage? \n If yes, please select the stage where you want to move the open tasks*",
  SELECT_STAGE: "Please select a stage",
  ADD_BOOKMARK: "Add Bookmark",
  BOOKMARKED: "Bookmarked",
  BOOKMARK: "Bookmark",
  PROJECT_BOOKMARK_ALERT: "Fav limit reached, remove to add",
  TASK_BOOKMARK_ALERT: "Fav limit reached, remove to add",
  QUEUE_BOOKMARK_ALERT: "Fav limit reached, remove to add",
  COPIED_TO_CLIPBOARD: "Task link copied to Clipboard!",
  WORKFLOW_COPIED_TO_CLIPBOARD: "Workflow link copied to Clipboard!",
  SMART_LINK_COPIED_TO_CLIPBOARD: "Smart link copied to Clipboard",
  HYPER_LINK_COPIED_TO_CLIPBOARD: "Hyper link copied to Clipboard",
  FORM_LINK_COPIED_TO_CLIPBOARD: "Form link copied to Clipboard",
  CMS_LINK_COPIED_TO_CLIPBOARD: " URL Link copied to Clipboard",
  NUDGE_SENT: "Nudge sent!",
  NUDGE_ACKNOWLEDGED: "Nudge acknowledged!",
  PROFILE_PREFERENCES: "Profile Preferences",
  MY_PROJECT: "My Project",
  RULES_WORKFLOWS: "Rules & Workflow",
  NO_NOTES_FOUND: "No Notes Found",
  ADD_STAGE_BEFORE_SAVING: "Please Add The Stage  Before Saving",
  BOOKMARK_MODAL_MESSAGE: "Are you sure you want to delete bookmark?",
  NEW_COMMENTS: "New Comments",
  NEW_PING: "Unread Pings",
  VIEW_COMMENTS: "View Comments",
  VIEW_PING: "View Ping",
  ADD_COMMENT: "Add Comment",
  ADD_PING: "Add Ping",
  NOTIFICATIONS: "Notifications",
  PROJECT_NAME: "Project Name",
  NO_NEW_NOTIFICATIONS: "No new notifications",
  COMMENT_TEXT_ERROR: "Something wrong with comment text! please check",
  EXISTING_REMINDERS: "Existing Reminders",
  NEW_REMINDER: "New Reminder",
  DELETE_TASK_TEXT: "Are you sure you want to delete this task?",
  PERSONAL_INITIATATED: "Initiated in Personal Board, switch to Team",
  TEAM_SWITCH: "Initiated in Team, switch to Personal Board",
  ADD_NEW_NOTE: "Add new note",
  CREATE_REMINDER: "New Reminder Title",
  REMINDER_TIME_HINT: "Hint: Select your Reminder time ",
  AT_LEAST_TWO_CHAR: "Type at least two characters",
  NO_RESULT_FOUND: "No results found",
  NO_DATA_FOUND: "No Data Found",
  CANNOT_DELEGATE_TASK: "Task cannot be further delegated if it is marked complete or is in the final stage!",
  PROJECT_NAME_LENGTH_ERROR: "Team name must contain atleast 4 characters",
  SELECT_LINK_TYPE: "Please select link type!",
  SHOW_ALL_TASKS: "All Tasks with Due Date",
  ENTER_VALID_DUEDAYS: "Please Enter Valid DueDays",
  COMMENTS_ADD_FOLLOWERS: "Do you want to add these users as Followers ? (They will be notified on Mentions)",
  SHIFT_ENTER_MESSAGE: "Shift + Enter to add a new line",
  PROJECT_FILE_SIZE_EXCEEDED: "File size must under 1 GB",
  TASK_FILE_SIZE_EXCEEDED: "File size must under 500 MB",
  PROJECT_SETTING: "Project Settings",
  HELP: "Help",
  AUTO_SAVE_LOADING: "Saving...",
  AUTO_SAVED: "Saved",
  PROCESS_APPROVAL: "Request Approval",
  APPROVAL: "Approval",
  REQUEST_FOR_APPROVAL: "Request for approval being processed, task is now locked",
  ALREADY_ON_HOLD: "Task approval is already on hold",
  SELECT_ACTION: "Please select action",
  SELECT_NEXT_ASSIGNEE: "Please select next approver",
  NOTE: "Note:",
  UNIQUE_ID_APPENDED: "Unique ID is automatically appended to all responses",
  STREAMS_FOR_USERS: "This stream will be shared with active users in the system.",
  STREAMS_FOR_TEAMS: "Stream will be shared with all active teams",
  STREAMS_SELECTED_TEAMS: "Stream will be shared with the selected team",
  STREAMS_WORKSPACE: "Stream will be shared with all users across all active workspaces.",
  STREAMS_SELECTED_WORKSPACE: "Stream will be shared with users from the selected workspace",
  STREAMS_FOR_ORGANISATION: "This stream will be shared with all active organisations",
  STREAMS_FOR_SELECTED_ORGANISATION: "This stream will be shared with selected organisations",
  STREAMS_FOR_DASHBOARD: "This stream will be shared with all active users in this project",
  MAC_RECURRENCE: "Task has been recreated as per the recurrence pattern",
  STREAMS_FOR_TEAM_USERS: "The stream will be shared to all users included in the project of this workspace",
  STREAMS_FOR_TEAM_PROJECTS: "The stream will be shared with selected teams/projects within this workspace",
  STREAMS_FOR_WORKSPACE: "The stream will be shared with all teams/projects within this workspace.",
  ONE_FILTER: "Please Select Atleast One Filter",
  SELECT_DATES: "Please select a start and end date to apply the recurrence",
  SELECT_VALID_END_DATE: "End by date should be after the first recurrence",
  SELECT_VALID_WEEK_DAY: "Please select a week day to apply the recurrence",
  SELECT_VALID_MONTH_DATE: "Please select a date to apply the recurrence",
  SELECT_VALID_COUNT: "Please select a valid count to apply the recurrence",
  SAVE_CURRENT_SCHEDULE_BEFORE_ADDING_NEW: "Please save the current schedule before adding a new one",
  ENTER_ALL_FIELDS: "Please enter all the required fields",
  MAKE_WORKFLOW_SHARED: "Change at least one workflow's privacy to open",
  PRIVACY_CHANGE: "The privacy of the project will be changed to",
  PROJECT_PRIVACY_RESTRICTED: "The project's privacy  will be updated to Restricted",
  DEFAULT_WORKFLOW_SHARED: "The default workflow of the Team has been set as shared",
  RESERVED_STAGE_NAME: "Reserved Stage Name",
  PLEASE_ADD_STAGE: "Please add a stage name",
  MAKE_SHARED_WORKFLOWS_CLOSED: "All shared workflows will be closed",
  WORKFLOW_DELETED: "The workflow has been deleted",
  CHOOSE_NEW_REPLACE_DEFAULT: "Choose a new workflow to replace the default one",
  TASK_RETURN: "Task will return to ",
  TASK_DELEGATED: "Task delegated to ",
  TASK_PASSED_ON: "Task passed on to ",
  WORKFLOW_NAME_REQUIRED: "Workflow name is required",
  SENT_VERIFICATION_MAIL: "Email verification request has been sent to your registered email",
  VERIFY_COMPANY_MAIL: "Verify Email to proceed further",
  COMPANY_UPDATED: "Organization Updated  Sucessfully",
  ORGANIZATION_UPDATED: "Organization set up complete",
  PROFILE_SETUP: "Profile set up complete",
  ADD_ALL_COMPANY_FIELDS: "Please add all fields before proceeding",
  ADD_COMPANY_FIELDS: "All fields must be completed",
  LIMIT_EXCEEDED: "Limit Exceeded",
  SHARING_DISABLED: "Sharing is disabled",
  MAIL_VERIFIED: "Verified",
  ADD_WORKFLOW: "Add Workflow",
  WORKFLOW_PRIVACY_RULE: "One workflow of the personal project should always be shared",
  WORKFLOW_ADDED: "Workflow Added",
  INVALID_REMINDER: "Please enter a valid reminder",
  APP_VERSION: "Application Version",
  TASK_CREATION_REQUIRED: "Task creation is required",
  CAN_NOT_COEXIST: "Two identical flow elements cannot coexist",
  UNACCESSED_WORKFLOW: "You do not have access to this Workflow",
  DELETION_NOT_ALLOWED: "Delete the upcoming element first to prevent the coexistence of two similar elements",
  FLOW_ELEMENT_ADDED: "Flow element added",
  FLOW_ELEMENT_DELETED: "Flow element deleted",
  SUBTASK_DELETED: "Subtask deleted",
  SUBTASK_ADDED: "Subtask added",
  CHILD_TASK_ADDED: "Child task added",
  CHILD_TASK_REMOVED: "Child task deleted",
  MAXIMUM_FILTER_LIMIT_REACHED: "Maximum Filter Name Limit Reached",
  TEAM_ADDED: "Team Added",
  SMART_LINK: "Smart Link",
  FILTER_LINK: "Filter link copied to Clipboard",
  URL: "URL",
  FILTER_NAME_EXCEEDS: "Filter name exceeds the maximum allowed limit. Please choose a different name",
  LOCK_CONFIRMATION: "Locking the task will restrict editing of the select fields & attachments. Do you want to proceed?",
  UNLOCK_CONFIRMATION: "Are you sure you want to unlock this task?",
  CLOSE_CONFIRMATION_LEAD: "This will end the task workflow immediately.",
  CLOSE_CONFIRMATION_BULLET_1: "Remaining steps and users will be bypassed.",
  CLOSE_CONFIRMATION_BULLET_2: "If reopened, the task will resume from this stage",
  CLOSE_CONFIRMATION_PROCEED: "Do you want to proceed?",
  WORKFLOW_USAGE: "Workflow Usage:",
  SAME_PAYLOAD_ERROR: "Change any field to enable Save Button",
  REQURED_FIELDS_ERROR: "Fill Required Fields to enable Save button",
  SAVE_BUTTON_ENABLED: "Save Button Enabled",
  EMAIL_IN_USE: "Email in use",
  TASKCODE_IN_CODE: "Task code in use",
  LOGIN_TYPES_DISABLE_ERROR: "Both login Types can't be disabled!",
  NOT_ALLOWED_TO_REMOVE_ADMIN: "At least one Admin should be present!",
  NOT_ALLOWED_TO_REMOVE_BILLING_OWNER: "At least one Billing Owner should be present!",
  REMINDER_INVALID_DATE: " Reminder date cannot be past the current date",
  UPPER_LIMIT_REACHED: " You can add only upto 5 reminders for a workflow",
  REMINDER_TITLE_EMPTY: "Reminder : Title cannot be empty",
  REMINDER_SET: "Reminder Set",
  FAILED_TO_ADD_REMINDER: "Failed to add reminder",
  OPERATION_CANCEL_MSG: "Operations cancelled due to new request",
  WORKFLOW_DELETE_CONFIRMATION: "Are you sure you want to delete this workflow?",
  PLAN_MY_DAY_MODE: "Oops!! please close the task to exit plan my day mode.",
  PLAN_COMPLETE_TASKS: "Task Completed",
  PLAN_DO_LATER: "Today's due dates and tasks pinned to your personal board.",
  ALL_TASK_PLANNED: "Thank you, all tasks have been planned for today.",
  TASK_SKIPPED: "Task Skipped",
  PLAN_DO_TODAY: "The task has been pinned and the due date has been adjusted to today's date.",
  PLAN_DO_TOMORROW: "The due date is set for tomorrow's date.",
  PLAN_REMOVE_DUE_DATE: "Due date removed for the task",
  PLAN_DUE_DATE_CUSTOM: "Due date set for",
  PLAN_SET_REMINDER_TOMORROW: "Reminder set for tomorrow",
  PLAN_SET_REMINDER_CUSTOM: "Reminder Set",
  CHOSEN_NOTIFICATION_TYPE: "Select the notifications that matter to you",
  AGREE_TO_RECEIVE_EMAIL: "I consent to receiving email communications.",
  EMAIL_VERIFICATION: "Email sent to your account",
  USE_MY_EMAIL: "Use My Email: ",
  INSERT_HYPERLINK_NOTIF: "Press ctrl+k to hyperlink selected text",
  WORKFLOW_DELETE_CONFIRMATION: "Are you sure you want to delete this workflow?",
  PRIVACY_POLICY: "Privacy Policy",
  HELP: "Help",
  USE_MY_EMAIL: "Use My Email: ",
  ACCOUNT_VERIFIED: "Email verified, Your account details have been sent to the Admin, please wait until your account is approved.",
  EMAIL_EXIST: "Email already exists , login please",
  EXPIRED_INVITE: "Expired invite, please request a new one",
  SIGNIN_OPTION: "Sign in options",
  DESC_MODE_UPDATE: "only mode creator can update the mode",
  WHAT_DO_YOU_NEED: "What do you need help with",
  CHOOSE_AN_ORGANIZATION: "Choose an Organization",
  CHOOSE_YOUR_ORGANIZATION_TO_LOG_IN: "Select your organization to log in.",
  BACK: "Back to Log In",
  SELECT_TAG: "Select a tag",
  ALL_COMMENTS_MARK_AS_READ: "All Comments Marked as Read",
  ATTACHMENT_DELETED_SURE: " Are you sure you want to delete this attachment ?",
  UP_TO_DATE: "Yay! You are up to date!",
  EMAIL_MARKED_AS_SPAM: "Email marked as spam ",
  NO_DESCRIPTION: "No description available",
  DOMAIN_EMAIL_ID_NOT_REGISTERED: "User email not registered in",
  SOMETHING_WENT_WRONG: "Oops! Something went wrong",
  TRY_AGAIN_LATER: "An unexpected error has occurred. Please try again later.",
  USER_DENIED_LOCATION: "User denied the request for Geolocation",
  INFORMATION_UNAVAILABLE: "Location information is unavailable",
  LOCATION_TIME_OUT: "The request to get user location timed out",
  UNKNOWN_ERROR: "An unknown error occurred",
  SHOW_MORE_LOGS: "Show More Logs",
  NO_FILTER: "No Filter",
  REMINDERS_FOR_DEFAULT_ASSIGNEE: "Reminders will be created for the default assignee",
  NO_DEFAULT_ASSIGNEE: " No Default Assignee for this task",
  UNABLE_TO_CONVERT_TASK: "Unable to convert subtask to task",
  EXPORT_SUCCESSFULLY: "Exported Successfully",
  TASK_ASSIGNMENT_NOTIFICATION: "has been assigned to you",
  CUSTOM_FILTER_NOT_FOUND: "Custom Filters Not Found",
  CREATE_FILTER: "Start by Creating a Filter",
  ENABLE_FEATURE_PROMPT: "No feature is enabled",
  ENABLE_FEATURE_TO_SEE_CONTENT: "Please enable this feature to see the content",
  ENABLED: "Enabled",
  DISABLED: "Disabled",
  ENABLED_API_ACCESS: "Enable API Access",
  DISABLED_API_ACCESS: "Disable API Access",
  NOT_IN_CURRENT_MONTH: "Selected date is not in the current month",
  INACTIVE_WORKFLOW_CONFIRMATION: "Are you sure you want to make this workflow inactive?",
  DISABLE_WORKFLOW_CONFIRMATION: "Are you sure you want to Disable this Workflow?",
  ENABLE_WORKFLOW_CONFIRMATION: "Are you sure you want to Enable this Workflow?",
  CHANGED_ACCOUNT_STATUS: "Account status changed",
  NO_LIBERARY: "No library items available",
  LOADING: "Loading...",
  VALUE_REQUIRED: "Please enter some value",
  MAX_PROMPT_CHARS: "Cannot be greater than 6000 characters",
  PDF_ONLY: "Only PDF files are allowed!",
  FILE_SIZE_EXCEEDS: "File size exceeds the 10MB limit",
  CONTENT_TYPE_PDF: "application/pdf",
  ALL_FILES_SYNCED: "All files are synced",
  NO_ACTIVITY_FOR_ORG: "No activities found",
  PROJECT_ALLOCATION_EXCEED: "Project allocation cannot exceed 100%",
  VALID_PROJECT_ALLOCATION: "Please select a valid project allocation",
  SUM_OF_BLOCK_CANNOT_EXCEED: "Total block assignment exceeds by ",
  SUM_OF_BLOCK_CANNOT_FALL: "Total block assignment falls short by ",
  MINIMUM_SELECTION: "You can only select a maximum of 200 items",
  SET_UP_JOB_ROLE: "Set up your job role in profile section to continue",
  ATTACHMENT_SYNC_FAIL: "Failed to sync attachments. Please check your network connection or try again later.",
  ACTIVE_CAN_NOT_DISABLED: "This feature is actively in use and cannot be disabled",
  ACTIVE_CAN_NOT_DELETED: "This feature is actively in use and cannot be deleted",
  PROJECT_ALLOCATION: "Project allocation updated successfully",
  PROJECT_ALLOCATION: "Updated successfully",
  VARIABLE_MAX_VALUE: "The maximum value cannot be less than 3.",
  NEW_FILE_NAME: "Enter new name for the file.",
  DELETE_SELECTED_FILE: "Are you sure you want to delete the selected",
  CANT_UNDO: "You cannot undo this action.",
  RESTORE_SELECTED_FILE: "Are you sure you want to restore the selected file?",
  NON_EMPTY_NAME: "Name cannot be empty. Please enter a valid name",
  NO_CUSTOM_FILTERS: "No Custom Filters",
  DIRECTORY_CONTENT: "When enabled, provides quick access to employee details",
  //BOOKMARK FEATURE IN KENDO-EDITOR
  BOOKMARK_COPIED_TO_CLIPBOARD: "Bookmark link copied to Clipboard!",
  BOOKMARK_TAG_ADDED: "Bookmark Added.",
  BOOKMARK_TAG_DELETED: "Bookmark deleted.",
  BOOKMARK_EXIST: "Bookmark already exists at the start of this paragraph.",
  FILE_SYN_FAILED: "File Sync Failed! Please try again",
  WAIT_FILE_LOADING: "Please wait while the file is loading......",
  SELECT_FOLDER: "Please select a library folder to add",
  SEARCH_TEAM_USER: "Search team /user",
  SEARCH_TEAM: "Search team",
  SEARCH_USER: "Search user",
  PREVIEW_LOADING: "Preview is Loading ...",
  CANT_MOVE_FOLDER_INTO_SELF: "Cannot move a folder into itself.",
  ALREADY_PRESENT: "The folder/file is already in this location.",
  CANT_MOVE_PARENT_TO_CHILD: "Cannot move a parent folder into its own child.",
  FILES_IN_TRASH: "Files in trash are automatically deleted after 30 days",
  PERMANENTLY_DELETE: "Content permanently deleted",
  CONTENT_DELTED: "Content attachment deleted",
  INVALID_DROP: "Invalid drop target",
  NEW_FILES_ADDED: "New Files Added",
  NEW_FOLDER_ADDED: "New Folder Added",
  NEW_DOC_ADDED: "New Doc Added",
  NEW_FILE_ADDED: "New File Added",
  FOLDER_UPDATED: "Folder Updated",
  DOC_UPDATED: "Doc Updated",
  FILE_UPDATED: "File Updated",
  FOLDER_DELETE: "Folder Moved to Trash",
  DOC_DELETED: "Document Moved to Trash",
  FILE_DELETED: "File Moved to Trash",
  FOLDER_RESTORED: "Folder Restored",
  DOC_RESTORED: "Document Restored",
  FILE_RESTORED: "File Restored",
  FOLDER_PERMANENT_DELETE: "Folder Permanently Deleted",
  DOC_PERMANENT_DELETE: "Document Permanently Deleted",
  FILE_PERMANENT_DELETE: "File Permanently Deleted",
  FOLDER_COPIED: "Folder Copied Successfully",
  DOC_COPIED: "Document Copied Successfully",
  FILE_COPIED: "File Copied Successfully",
  FAVORITE: "Favorite",
  REMOVE_FAVORITE: "Remove Favorite",
  NO_CONVERSATION: "No conversation data available",
  MAX_LIMIT_REACHED: "Max Limit Reached",
  ENTER_DESCRIPTION: "Enter description here",
  ENTER_API_NAME: "Enter API name",
  API_KEY_COPIED: "API key copied to clipboard",
  API_DELETED: "API Key Deleted",
  API_KEY_REGENERATED: "API Key Regenerated",
  NO_WORKFLOWS_LINKED: "No workflows linked",
  API_KEY_CREATED: "API Key Created",
  API_KEY_UPDATED: "API Key Updated",
  FOLDER_NAME_EMPTY: "Folder name cannot be empty",
  GROUP_CREATED: "Group Created",
  GROUP_DELETED: "Group Deleted",
  EXISTS_IN_GROUPS: "Group Already Exist, Please Select Another Name",
  GROUP_UPDATED: "Group Details Updated",
  ACTION_FAILED: "Action Failed",
  WORKFLOW_ADD_DISABLED: "You are not authorized to add workflows",
  TEAM_CHIPS_MANAGE_DISABLED: "Only a Project Manager can add, edit, or delete chips for this team.",
  FORM_ADD_DISABLED: "You are not authorized to add forms",
  FORM_NAME_ALREADY_EXISTS: "Name already exists. Please choose another name.",
  FORM_NAME_REQUIRED: "Form name is required.",
  AUTOMATION_ADD_DISABLED: "You are not authorized to add automations",
  DELETE_WORKSPACE: "Are you sure you want to delete the workspace",
  DELETE_WORKSPACE_CONFIRMATION: "This action cannot be undone.",
  REPLY_ADDED_SUCCESSFULLY: "Reply added successfully!",
  EMOJI_ADDED_SUCCESS: "Emoji added!",
  SELECT_ORGANIZATION: "Please select an organization to continue",
  INVALID_NUMBER_OR_ORG: "Invalid organization or phone number",
  FAILED_OTP: "Failed to generate OTP",
  SELECT_YOUR_ORGANIZATION: "Please select your organization",
  REFRESH_SUCCESS: "Refreshed Successfully",
  ACCESS_DENIED: "Access Denied",
  NOT_HAVE_PERMISSION: "You do not have permission to view this page.",
  LOADING_SIGN_IN_OPTIONS: "Loading sign-in options...",
  NO_SIGN_IN_METHODS_AVAILABLE: "No sign-in methods available",
  FAILED_TO_LOAD_SIGN_IN_OPTIONS: "Failed to load sign-in options, Please try refreshing the page",
  USE_ANOTHER_METHOD: "Use another method",
  SIGN_IN_WITH_PASSWORD: "Sign in with password",
  INVALID_TENANT: "Invalid tenant or tenant not found",
  FILE_MUST_BE_AN_IMAGE: "File must be an image",
  FAILED_TO_GET_GOOGLE_USER_INFORMATION: "Failed to get Google user information",
  USER_DOES_NOT_HAVE_ACCESS_TO_THIS_ORGANIZATION: "User does not have access to this organization. Please contact your administrator.",
  USER_NOT_FOUND_IN_ANY_ORGANIZATION: "User not found in any organization",
  MARKED_AS_DONE: "Comment marked as seen",
  NO_AUTOMATIONS_FOUND: "No automations found. Create your first automation to get started.",
  QUICK_INFO_MIN_CHARS: "Quick info must be at least 10 characters",
  NAME_MIN_CHARS: "Name must be at least 3 characters",
  A_GROUP_MUST_BE_SELECTED_BEFORE_ADDING_A_TRIGGER: "A group must be selected before adding a trigger",
  SELECT_USERS_FOR_THE_CURRENT_GROUP: "Please select users for the current group before triggering automation",
  AUDIENCE_HAS_NO_MEMBERS: "Audience does not have any members.",
  SELECT_USERS_FOR_THE_CURRENT_GROUP_BEFORE_ADDING_TRIGGERS: "Please select users for the current group before adding triggers",
  INVALID_MOBILE_NUMBER: "Please enter a valid 10-digit mobile number",
  ON_SAVE: "Form saved",
  ON_UPDATE: "Form updated",
  OPERATIONAL_TEAM_QUOTE: "The global display name for teams or projects throughout your organization.",
  REPORTING_MANAGER_QUOTE: "Identifies the primary manager attribute used for approval workflows and organization charts.",
  FOLLOWER_MAIL_INTERVAL_QUOTE: "Sets the frequency for automated notification emails sent to task followers.",
  TIMEZONE_QUOTE: "The default time zone for your organization. Establishes the default timestamp for deadlines and system logs.",
  NO_DATA_AVAILABLE: "No data available",
  NO_TRIGGER_SELECTED: "No trigger selected",
  TRIGGER_SAVED_SUCCESSFULLY: "Trigger saved successfully",
  FAILED_TO_SAVE_TRIGGER: "Failed to save trigger",
  ERROR_SAVING_TRIGGER: "Error saving trigger: ",
  TRIGGER_SAVED_LOCALLY: "Trigger saved locally. It will be saved to server when automation is saved.",
  DELETE_HANDLER_NOT_AVAILABLE: "Delete handler not available",
  TRIGGER_DELETED_SUCCESSFULLY: "Trigger deleted successfully",
  FAILED_TO_DELETE_TRIGGER: "Failed to delete trigger",
  AT_LEAST_ONE_SCHEDULE_REQUIRED: "At least one schedule is required. Cannot delete the last schedule.",
  CANNOT_DELETE_LAST_SAVED_SCHEDULE_WITH_DRAFT:
    "Save or remove the unsaved schedule before deleting the last saved schedule.",
  FAILED_TO_CREATE_AUTOMATION: "Failed to create automation. Please try again.",
  FAILED_TO_SAVE_AUDIENCE: "Failed to save audience. Please try again.",
  ERROR_SAVING_TRIGGER_WITH_MESSAGE: "Error saving trigger: ",
  SAVE_HANDLER_NOT_AVAILABLE: "Save handler not available. Please refresh and try again.",
  WIDGET_ADDED_TO_HOME_PAGE: "Widget added to Home Page",
  FAILED_TO_ADD_WIDGET: "Failed to add widget",
  UNKNOWN_ERROR: "Unknown error",
  CLICK_TO_EDIT_ALLOCATION: "Click to edit allocation",
  ERROR_FETCHING_USER_ENGAGEMENTS: "Error fetching user engagements:",
  ERROR_FETCHING_MANAGER_AND_PEERS: "Error fetching manager and peers:",
  ERROR_ADDING_WIDGET: "Error adding widget:",
  REMOVE_USER_FIRST_CONFIRMATION: "Are you sure you want to remove this user? This will permanently delete the user and revoke any existing invites.",
  REMOVE_USER_FINAL_CONFIRMATION: "This action cannot be undone. The user will be permanently removed and can restart onboarding later.",
  NO_FORM_DATA_AVAILABLE: "No data available",
  NO_DESCRIPTION_ADDED: "No description added",
  NO_APPROVAL_INITIATED: "No approval initiated",
  ERROR_FETCHING_FORM_DATA_FOR_EXPORT: "Error fetching form data for export:",
  LAST_FLOW_ELEMENT: "Last Flow Element",
  NO_OPTIONS_MATCH_YOUR_SEARCH: "No options match your search.",
  TRIGGER_NAME_ALREADY_EXISTS: "Trigger name already exists. Please use a different name.",
  AUTOMATION_NAME_ALREADY_EXISTS: "Automation name already exists. Please use a different name.",
  ERROR_STORING_KPI_INDICATOR_TO_INDEXEDDB: "Could not save KPI preferences, it may not persist after refresh",
  CLICK_TO_REMOVE_FROM_FORM: "Click to remove from form",
  COMPANY_INFO: "Company Info",
  FIND_BY_NAME_OR_EMAIL: "Find by name or email...",
  READ_MORE: "Read more",
  USER_HAS_DEPENDENCIES: "User has pending tasks. Cannot remove user.",
  FILTERS_CLEARED: "Filters Cleared",
};

export const action = {
  CONFIRM: "confirm",
  HIDE: "hide",
  ACTIVE: "active",
  PUSH: "push",
  EMAIL: "email",
  REMOVE: "remove",
};

export const button = {
  EDIT_LAYOUT: "Edit Layout",
  LOGS: "Logs",
  LOGIN: "Log In",
  SIGNUP: "Get Started Now",
  FORGOT_PASSWORD: " Send reset link",
  SIGNUP_WITH_GOOGLE: "Sign Up with Google",
  LOGIN_WITH_GOOGLE: "Continue with Google",
  LOGIN_WITH_PASSWORD: "Continue with Password",
  LOGIN_WITH_PHONE: "Continue with Mobile",
  CHANGE_PASSWORD: "Change Password",
  ADMIN_CONSOLE: "Admin Console",
  LOGOUT: "Logout",
  USER_PROFILE: "User Profile",
  RESET_PASSWORD: "Reset password",
  APPROVE_REQUEST: "Approve Request",
  CREATE: "Create Project",
  CANCEL: "Cancel",
  RENAME: "Rename",
  ADD_PROJECT: "Add Project",
  SAVE: "Save",
  SAVE_AS: "Save As",
  DELETE_ORGRANIZATION: "Remove Organization",
  RESEND_INVITE: "Resend Invite",
  CONTINUE: "Continue",
  REMOVE_USER: "Remove User",
  ADD_QUEUE: "Add Workspace",
  DELETE_QUEUE: "Delete Workspace",
  MOVE_PROJECTS: "Move",
  PRIMARY: "Primary",
  SECONDARY: "Secondary",
  EDIT_WORKFLOW: "Edit Workflow",
  CLONE_PROJECT: "Clone Project",
  DELETE_PROJECT: "Delete Project",
  DONE: "Apply",
  TEAM_INSIGHTS: "Team Insights",
  CLEAR: "Reset",
  DELETE_TASK: "Delete",
  ARCHIVE_TASK: "Archive Task",
  UNARCHIVE_TASK: "Unarchive Task",
  COMMENT_REPLY: "Reply",
  COMMENT_EDIT: "Edit",
  COMMENT_DELETE: "Delete",
  COMMENT_MAKE_PUBLIC: "Make Public",
  REMIND_ME: "Remind Me",
  LOAD_MORE_COMMENTS: "Load more",
  NO: "No",
  YES: "Yes",
  SEE_ALL_NOTIFICATIONS: "See all notifications",
  CLEAR_ALL: "Clear All",
  SUPER_ADMIN_CONSOLE: "Superadmin Console",
  STOP: "Stop",
  SAVE_REMINDER: "Save Reminder",
  CLONE_TASK: "Clone",
  ADD_CHILD_TASK: "Child Task",
  ADD_FLOW_ELEMENT: "Flow Element",
  ADD_WORKFLOW: "Add Workflow",
  STAGE: "Stage",
  ADD_NEW_STAGE: "New Stage",
  SUBMIT: "Submit",
  SHOW_LESS: "Show less",
  READ_MORE: "Read more",
  DEFAULT: "Default",
  VERIFY_EMAIL: "Verify Email",
  CREATE: "Create",
  ADD_NEW_STAGE: "Add New Stage",
  ADD: "Add",
  ADDING: "Adding...",
  SAVING: "Saving...",
  SYNC_ALL: "Sync All",
  IN_PROGRESS: "In Progress",
  MOVE_TEAM: "Move Team",
  CANCEL_EDIT: "Cancel Edit",
  LOCK_TASK: "Lock",
  UNLOCK_TASK: "Unlock Task",
  LOCKED: "Locked",
  BOOKMARK_TASK: "Bookmark",
  BOOKMARKED_TASK: "Bookmarked",
  NEXT: "Next",
  BACK: "Back",
  DONE_SETUP: "Done",
  MERGE_TAGS: "Merge Tags",
  APPLY: "Apply",
  TRY_AGAIN: "Try Again",
  VALID_URL: "Please enter a valid URL.",
  CLOSE: "Close",
  EXPORT_TO_EDITOR: "export to editor",
  COLLAB_CENTRAL: "Collab Central",
  MY_DRAWINGS: "My Drawings",
  UPLOADING: "Uploading...",
  UPLOAD: "Upload",
  UPLOAD_AND_SYNC: "Upload & Sync File",
  SAVE_PROMPT: "Save Prompt",
  ADD_FOLDER: "Add Folder",
  FAVORITE: "Add Favorite",
  ADD_API: "+ Add API",
  CREATE_FOLDER: "Create Folder",
  ADD_GROUP: "+ Add Group",
  ADD_MEMBERS: "+ Add Members",
  CONTINUE: "Continue",
  BACK_TO_HOME: "Back to Home",
  SAVE_LAYOUT: "Save Layout",
  SAVE_TRIGGER: "Save Trigger",
  PRESET: "Preset",
  CUSTOM: "Custom",
  TRIGGER_NOW: "Trigger Now",
  DISABLE: "Disable",
  ENABLE: "Enable",
  EDIT_WORKFLOW: "Edit Workflow",
  EDIT_PARENT_WORKFLOW: "Edit Parent Workflow",
  EDIT_FORM: "Edit Form",
  FAV_ONLY: "Favorites Only",
};

export const icon = {
  REPLY_EMAIL: <SendHorizontal className='lucid-icon-common' />,
  AZ_DOWN: <ArrowDownAz className='lucid-icon-common' />,
  BOOK_OPEN_TEXT_T: <Type className='lucid-icon-common' />,
  SQUARE_FUNCTION: <SquareFunction className='lucid-icon-common' />,
  MICROCHIP: <Microchip className='lucid-icon-common' />,
  CONTACT_ROUND: <ContactRound className='lucid-icon-common' />,
  COLLAB_CENTRAL_APP: <Component className='lucid-icon-common' />,
  USERS_ADD: <Users className='lucid-icon-common' />,
  SKIP_STAGE: <RedoDot className='lucid-icon-common' />,
  EDIT_EMAIL: <Pencil className='lucid-icon-common' />,
  EDIT_ICON_2: <Pencil className='lucid-icon-common' />,
  BOARD_DIRECTORY_APP: <House className='lucid-icon-common ' />,
  DIRECTORY_APP: <IdCard className='lucid-icon-common ' />,
  COMMENT_APP: <MessagesSquare className='lucid-icon-common ' />,
  APP_WORKSPACE: <Network className='lucid-icon-common ' />,
  APP_FORM: <ClipboardList className='lucid-icon-common ' />,
  APP_AUTOMATION: <ListTodo className='lucid-icon-common ' />,
  APP_SHEETS: <LayoutGrid className='lucid-icon-common ' />,
  APP_LIBRARY: <FolderOpenDot className='lucid-icon-common ' />,
  QUICK_ACCESS_APP: <FolderClock className='lucid-icon-common ' />,
  COST_CENTER_APP: <Receipt className='lucid-icon-common ' />,
  APP_STREAM: <Mic className='lucid-icon-common ' />,
  ADD_TASK_APP: <CircleCheckBig className='lucid-icon-common ' />,
  CANVAS_APP: <NotebookPen className='lucid-icon-common ' />,
  WF_ELEMENT: <SquaresExclude className='lucid-icon-common ' />,
  DYNAMIC: <Zap className='lucid-icon-common ' />,
  DYNAMIC_FLOW: <TrendingUpDown className='lucid-icon-common ' />,
  SWAP_VERT: <ArrowDownUp className='lucid-icon-common' />,
  PACKAGE_MAILBOX: <Album className='lucid-icon-common ' />,
  SMART_CHIP: <Microchip className='lucid-icon-common ' />,
  REFRESH_APP: <RotateCcw class='lucid-icon-common' />,
  FLAG_2: <Flag className='lucid-icon-common' />,
  SWITCH_WARNING: <TriangleAlert className='lucid-icon-common text-warning' />,
  EMAIL_INBOX: <Archive className='lucid-icon-common ' />,
  DRAFTS_EMAILS: <File className='lucid-icon-common ' />,
  SEND_EMAILS: <SendHorizontal className='lucid-icon-common ' />,
  ARROW_DROP_DOWN_ICON_INBOX: <Play className='lucid-icon-common filled-icon' />,
  ACKNOWLEDGE_ICON: <CheckLine className='lucid-icon-common' />,
  ARROW_DROP_UP_ICON_INBOX: <ChevronDown className='lucid-icon-common filled-icon-inbox' />,
  EMAIL_TRASH: <Trash2 className='lucid-icon-common ' />,
  MORE_STREAM_FUNCTION: <EllipsisVertical className='lucid-icon-common ' />,
  EMAIL_SPAM: <OctagonAlert className='lucid-icon-common ' />,
  RED_FILE_SAVE: <FileDown className='lucid-icon-common red cursor-pointer ' />,
  ATR: <Component className='lucid-icon-common app-color' />,
  ADD_DEPARTMENT:<SquareUser className='lucid-icon-common' />,
  GLOBAL_ICON: <Vault className='lucid-icon-common' />,
  TIME_BLOCK_ICON: <ClockPlus className='lucid-icon-common' />,
  CALENDER_MONTH: <CalendarDays className='lucid-icon-common app-color' />,
  NOTIFICATIONS_ICON: <Volume2 className='lucid-icon-common app-color' />,
  ACKNOWLEDGE_ICON: <CheckLine className='lucid-icon-common' />,
  LAYERS: <Layers2 className='lucid-icon-common ' />,
  CLOUD: <BookText className='lucid-icon-common ' />,
  CLOUD_TEAM: <BookText className='lucid-icon-common app-color' />,
  SIDEBAR_APPS: <Grip className='lucid-icon-common white' />,
  BADGE_TEAM: <IdCard className='lucid-icon-common app-color ' />,
  CLOUD_DONE: <CloudCheck className='lucid-icon-common ' />,
  ASSIGNMENTICON: <ClipboardList className='lucid-icon-common' />,
  USER_FAVORITE: <Star className='lucid-icon-common text-muted ' />,
  USER_REMOVE: <Star className=' lucid-icon-common  text-favorite filled-icon ' />,
  GRID_ICON: <List className='lucid-icon-common ' />,
  PIVOT_ICON: <Columns3 className='lucid-icon-common ' />,
  PIVOT_ICON_BLUE: <Columns3 className='lucid-icon-common app-color' />,
  ANALYTICS_ICON_BLUE: <ChartLine className='lucid-icon-common app-color' />,
  ANALYTICS_ICON: <ChartLine className='lucid-icon-common' />,
  MY_TEAM: <Users className='lucid-icon-common app-color' />,
  MY_TEAM_SIDEBAR: <Users className='lucid-icon-common' />,
  ENGAGEMENT_ICON: <ChartPie className='lucid-icon-common' />,
  TEAM_CONNECT: <NotebookPen className='lucid-icon-common ' />,
  TEAM_CONNECT_TEAMS: <NotebookPen className='lucid-icon-common app-color' />,
  STREAM_ICON_TEAMS: <Mic className='lucid-icon-common app-color' />,
  STREAM_ICON: <Podcast className='lucid-icon-common' />,
  FILE_SAVE: <FileDown className='lucid-icon-common' />,
  FILE_UNDO: <Undo2 className='lucid-icon-common' />,
  ARROW_BACK_IOS_EMAIL: <ChevronLeft className='lucid-icon-common' />,
  ARROW_FORWARD_IOS: <ChevronRight className='lucid-icon-common' />,
  DRAFTS: <MailOpen className='lucid-icon-common' />,
  REPORT: <OctagonAlert className='lucid-icon-common' />,
  ALLEMAIL: <Inbox className='lucid-icon-common' />,
  MARK_EMAIL_UNREAD: <Mail className='lucid-icon-common' />,
  MAIL_ICON: <Mail className='lucid-icon-common' />,
  MAIL_OPEN_ICON: <MailOpen className='lucid-icon-common' />,
  BOOMARK_CHECK: <BookmarkCheck className='lucid-icon-common' />,
  DELETE_ICON_EMAIL: <Trash2 className='lucid-icon-common cursor-pointer ' />,
  WARNING: <TriangleAlert className='lucid-icon-common' />,
  SETTING: <MonitorCog className='lucid-icon-common' />,
  HELP: <CircleQuestionMark className='lucid-icon-common' />,
  CLOCK: <Clock4 className='lucid-icon-common' />,
  MOVE: <Move className='lucid-icon-common fa-rotate-plus-45 ' />,
  AUTOMATION: <Move className='lucid-icon-common' />,
  IMAGE: <Image className='lucid-icon-common' />,
  PRIORITY: <ListStart className='lucid-icon-common' />,
  FRAME_RELOAD: <Scan className='lucid-icon-common' />,
  APP_REGISTRATION: <LayoutGrid className='lucid-icon-common' />,
  TASK_ALT: <CircleCheckBig className='lucid-icon-common' />,
  ASSIGNMENT: <ClipboardList className='lucid-icon-common' />,
  ALARM: <AlarmClock className='lucid-icon-common' />,
  TOOLTIP: <MessageSquare className='lucid-icon-common' />,
  CHECK_CIRCLE: <CircleCheck className='lucid-icon-common' />,
  BADGE: <IdCard className='lucid-icon-common' />,
  CAMPAIGNS: <Volume2 className='lucid-icon-common' />,
  EMAIL_ICON_BLUE: <Mail className='lucid-icon-common app-color' />,
  EMAIL_ICON: <Mail className='lucid-icon-common' />,
  FILTER: <Images className='lucid-icon-common' />,
  GROUP_ADD: <UserPlus className='lucid-icon-common' />,
  DND: <CircleMinus className='lucid-icon-common cursor-pointer' />,
  FOLLOWED: <Eye className='lucid-icon-common' />,
  ADD_JOB_ROLE: <Eye className='lucid-icon-common' />,
  ZAP: <Zap className='lucid-icon-common zap-icon-stroke' />,
  GLOBAL_NOTIFICATION: <Bell className='lucid-icon-common cursor-pointer mr-2' />,
  EMAIL_NOTIFICATION: <Mail className='lucid-icon-common cursor-pointer' />,
  PROJECTS: <Users className='lucid-icon-common ' />,
  TASKS: <List className='lucid-icon-common' />,
  QUEUES: <Users className='lucid-icon-common cursor-pointer ' />,
  WORKFLOW: <Network className='lucid-icon-common cursor-pointer' />,
  ACTIVITY_DIGEST: <Volume2 className='lucid-icon-common cursor-pointer campaign-icon' />,
  INBOX: <MessagesSquare className='lucid-icon-common cursor-pointer' />,
  CALENDAR: <Calendar1 className='lucid-icon-common cursor-pointer' />,
  HELP_SUPPORT: <LifeBuoy className='lucid-icon-common cursor-pointer' />,
  DVR: <Users className='lucid-icon-common cursor-pointer material-symbols-fill filled-icon' />,
  SEARCH: <Search className='lucid-icon-common cursor-pointer align-middle' />,
  DESCRIPTION_ICON: <FileText className='lucid-icon-common' />,
  GROUP: <Users className='lucid-icon-common' />,
  PERSON_SINGLE: <User className='lucid-icon-common' />,
  SEARCH: <Search className='lucid-icon-common' />,
  ARROW_DROP_DOWN_ICON: <ChevronDown className='lucid-icon-common filled-icon' />,
  // CREATE_AI_INSIGHT: <CircleStar className='lucid-icon-common' />,
  MANAGE_PROJECTS: (
    <Users
      data-toggle='tooltip'
      data-placement='bottom'
      className='lucid-icon-common cursor-pointer  '
      title={route.ADMIN_ROUTE.MANAGE_PROJECTS.PROPS.HEADER}
    />
  ),
  ADD_BOX: <SquarePlus className='lucid-icon-common cursor-pointer' />,
  ACCOUNT_CIRCLE: <CircleUser className='lucid-icon-common account-circle-icon-stroke' />,
  UNASSIGNED_USER: <UserX className='lucid-icon-common black' />,
  TEAM_ACCOUNT_CIRCLE: <CircleUser className='lucid-icon-common cursor-pointer team-account' />,
  HOME: <House className='lucid-icon-common cursor-pointer' />,
  DASHBOARD: <House className='lucid-icon-common cursor-pointer' />,
  BUSINESS: (
    <Building2
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.MANAGE_ORGANIZATION.PROPS.HEADER}
    />
  ),
  USAGE_SUMMARY: (
    <ChartNoAxesCombined
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.USAGE_SUMMARY.PROPS.HEADER}
    />
  ),
  MANAGE_ORGANIZATION: (
    <Building2
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.MANAGE_ORGANIZATION.PROPS.HEADER}
    />
  ),
  LOCK: <Lock className='lucid-icon-common cursor-pointer red material-symbols-fill' />,
  DROPDOWN: <CircleChevronDown className='lucid-icon-common cursor-pointer' />,
  LOCK_UNFILLED: <Lock className='lucid-icon-common cursor-pointer' />,
  TASK_LOCK: <Users className='lucid-icon-common cursor-pointer maroon material-symbols-fill filled-icon' />,
  TASK_LOCKED_OUTLINED: <Users className='lucid-icon-common black material-symbols-fill filled-icon' />,
  TASK_LOCKED_OUTLINED_DARK_MODE: <Users className='lucid-icon-common white material-symbols-fill filled-icon' />,
  ADMIN_SETTINGS: <ShieldUser className='lucid-icon-common cursor-pointer mr-2' />,
  ADMIN_SETTINGS_2: <Settings className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Settings' />,
  LOGOUT: <LogOut className='lucid-icon-common cursor-pointer mr-2' />,
  HIVE: <Octagon className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Hive' />,
  SIDE_COLLAPESE: <LogOut className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Collapse' />,
  MENU: <Equal className='lucid-icon-common' />,
  GROUPS_ICON: <Users className='lucid-icon-common cursor-pointer material-symbols-fill' />,
  GROUPS: <Users className='lucid-icon-common cursor-pointer material-symbols-fill' />,
  ACCOUNT_TREE: <CircuitBoard className='lucid-icon-common cursor-pointer' />,
  CAMPAIGN: <Volume2 className='lucid-icon-common cursor-pointer  campaign-icon' />,
  RATE_REVIEW: <PencilLine className='lucid-icon-common cursor-pointer' />,
  VISIBILITY: <Eye className='lucid-icon-common cursor-pointer' />,
  VISIBILITY_OFF: <EyeOff className='lucid-icon-common cursor-pointer' />,
  FILTER_ICON: <Funnel className='lucid-icon-common' />,
  DIFFERENCE: <MessageSquareDiff className='lucid-icon-common cursor-pointer' />,
  EDIT_BORDER: <SquarePen className='lucid-icon-common cursor-pointer' />,
  PERSON_TOGGLE: <User className='lucid-icon-common material-symbols-fill' data-toggle='tooltip' data-placement='bottom' />,
  TRANSFER: <ArrowLeftRight className='lucid-icon-common cursor-pointer' />,
  PROJECTS_TOGGLE: (
    <Users
      className='lucid-icon-common material-symbols-fill filled-icon'
      data-toggle='tooltip'
      data-placement='bottom'
      title={"Search Projects"}
    />
  ),
  PERSON: (
    <User
      className='lucid-icon-common cursor-pointer filled-icon'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.MANAGE_USERS.PROPS.HEADER}
    />
  ),
  HISTORY: (
    <History
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.ACTIVITY_LOG.PROPS.HEADER}
    />
  ),
  ACTIVITY_LOG: (
    <ClockFading
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.ACTIVITY_LOG.PROPS.HEADER}
    />
  ),
  SUMMARIZE: (
    <ChartNoAxesCombined
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.USAGE_SUMMARY.PROPS.HEADER}
    />
  ),
  CLOUD_STORAGE: (
    <CloudCheck
      className='lucid-icon-common cursor-pointer'
      data-toggle='tooltip'
      data-placement='bottom'
      title={route.ADMIN_ROUTE.MANAGE_UTILIZATION.PROPS.HEADER}
    />
  ),
  RESET: <RotateCcw className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Reset' />,
  ELLIPSIS_HORIZ: <Ellipsis className='lucid-icon-common cursor-pointer' />,
  PERSON_BLUE: <User className='lucid-icon-common cursor-pointer filled-icon blue' />,
  PERSON_RED: <User className='lucid-icon-common cursor-pointer filled-icon red' />,
  PERSON_GREEN: <User className='lucid-icon-common cursor-pointer filled-icon green' />,
  PERSON_PURPLE: <User className='lucid-icon-common cursor-pointer filled-icon purple' />,
  PERSON_ORANGE: <User className='lucid-icon-common cursor-pointer filled-icon orange' />,
  PERSON_GREY: <User className='lucid-icon-common cursor-pointer filled-icon grey' />,
  PERSON_YELLOW: <User className='lucid-icon-common cursor-pointer filled-icon yellow' />,
  PERSON_PINK: <User className='lucid-icon-common cursor-pointer filled-icon pink' />,
  PERSON_MAROON: <User className='lucid-icon-common cursor-pointer filled-icon maroon' />,
  IMPORT_FILE: <Download className='lucid-icon-common cursor-pointer' />,
  SETTINGS: (
    <Settings
      className='lucid-icon-common cursor-pointer material-symbols-fill'
      data-toggle='tooltip'
      data-placement='bottom'
      title='Settings'
    />
  ),
  HELP_OUTLINE: <BadgeQuestionMark className='lucid-icon-common cursor-pointer' />,
  PRIVACY_PUBLIC: <Globe className='lucid-icon-common cursor-pointer' />,
  PRIVACY_TEAM: <Users className='lucid-icon-common cursor-pointer material-symbols-fill filled-icon' />,
  PROJECT_ICON: <Users className='lucid-icon-common cursor-pointer material-symbols-fill filled-icon' />,
  EDIT_TASK: <Pencil className='lucid-icon-common cursor-pointer opacity-7' title='Edit Task' />,
  PIN_TASK: <Pin className='lucid-icon-common material-symbols-fill blue-color-pin' />,
  UNPIN_FILTER: (
    <Pin
      className='lucid-icon-common material-symbols-fill blue-color-pin fa-rotate-minus-45'
      data-toggle='tooltip'
      data-placement='bottom'
    />
  ),
  PIN_FILTER: <Pin className='lucid-icon-common material-symbols-fill' data-toggle='tooltip' data-placement='bottom' title='Pin To Board' />,
  UNPIN_TASK: <Pin className='lucid-icon-common  opacity-7' />,
  PIN_TASK_GRID: (
    <span className='wrapper'>
      Pinned{" "}
      <span className='pin-icon box'>
        <Pin className='lucid-icon-common material-symbols-fill blue-color-pin ' />
      </span>
    </span>
  ),
  EDIT_PROJECT: <Pencil className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Edit Project' />,
  DONE: <Check className='lucid-icon-common cursor-pointer' />,
  CORRECT: <Check className='lucid-icon-common cursor-pointer' />,
  CLEAR: <X className='lucid-icon-common cursor-pointer' />,
  PERSON_ADD: <UserPlus className='lucid-icon-common material-symbols-fill cursor-pointer' />,
  CLOSE_COMMENT: <X className='lucid-icon-common cursor-pointer' />,
  CLOSE: <X className='lucid-icon-common' />,
  CLOSE_TASK_DUE_DATE: <X className='lucid-icon-common cursor-pointer' />,
  CANCEL_FILE: <CircleX className='lucid-icon-common cursor-pointer' />,
  ADD_USERS: <UserPlus className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Add Member' />,
  DELETE: <CircleX className='lucid-icon-common cursor-pointer' />,
  SORT: <ListFilter className='lucid-icon-common cursor-pointer' />,
  EXPORT_CSV: <Download className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Export CSV' />,
  INVITE_USERS: <UserPlus className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Invite Users' />,
  CHEVRON_UP: <ChevronUp className='lucid-icon-common' />,
  ASCENDING: <MoveUp className='lucid-icon-common' />,
  DESCENDING: <MoveDown className='lucid-icon-common' />,
  ARROW_UPDOWN: <ArrowUpDown className='lucid-icon-common' />,
  CHEVRON_DOWN: <ChevronDown className='lucid-icon-common' />,
  MULTIDIMENSION : <FileStack className='lucid-icon-common' />,
  CHEVRON_UP: <ChevronUp className='lucid-icon-common' />,
  CHECK_TICK: <Check className='lucid-icon-common' />,
  VERTICAL_ALIGN_TOP: <ArrowUpToLine className='lucid-icon-common' />,
  VERTICAL_ALIGN_BOTTOM: <ArrowDownToLine className='lucid-icon-common' />,
  LEFT: <ChevronLeft className='lucid-icon-common' />,
  RIGHT: <ChevronRight className='lucid-icon-common' />,
  RIGHT_BREADCRUMB: <ChevronRight className='lucid-icon-common' />,
  GRID: <LayoutList className='lucid-icon-common' />,
  DRAG_INDICATOR: <GripVertical className='lucid-icon-common' />,
  NOTIFICATION: (
    <Volume2
      className='lucid-icon-common cursor-pointer material-symbols-fill'
      data-toggle='tooltip'
      data-placement='bottom'
      title='Notifications'
    />
  ),
  DARK_MODE: <Moon className='lucid-icon-common mr-2' />,
  LIGHT_MODE: <Sun className='lucid-icon-common mr-2' />,
  HEADSET: (
    <Headset
      className='lucid-icon-common cursor-pointer material-symbols-fill'
      data-toggle='tooltip'
      data-placement='bottom'
      title='Help & Support'
    />
  ),
  EDIT_NOTES: <NotepadText className='lucid-icon-common cursor-pointer ' data-toggle='tooltip' data-placement='bottom' title='Notes' />,
  RECENT: <FileClock className='lucid-icon-common cursor-pointer' />,
  CLONE_WORKFLOW: <Copy className='lucid-icon-common' />,
  WORKFLOW_LUCID: <BetweenHorizontalEnd className='lucid-icon-common' />,
  WORKFLOW_ICON: (
    <span className='workflow-icon'>
      <ListEnd className='lucid-icon-common d-inline-block low-priority-icon' />
    </span>
  ),
  DEFAULT_PROJECT: <Award className='lucid-icon-common' data-toggle='tooltip' data-placement='bottom' title='Default Workflow' />,
  FORWARD_ARROW: <Reply className='lucid-icon-common icon-mirror cursor-pointer' />,
  LINK_FIELD: <Link className='lucid-icon-common ' />,
  EXPAND_CIRCLE_DOWN: <CircleChevronDown className='lucid-icon-common cursor-pointer' />,
  EXPAND_CIRCLE_DOWN_FILLED: <CircleChevronDown className='lucid-icon-common cursor-pointer' />,
  ARROW_UP: <ChevronUp className='lucid-icon-common' />,
  ARROW_DOWN: <ChevronDown className='lucid-icon-common filled-icon' />,
  INFO: <Info className='lucid-icon-common cursor-pointer' />,
   UPLOAD : <Upload className='lucid-icon-common' />,
  DESCRIPTION: <FileType2 className='lucid-icon-common cursor-pointer' />,
  FORMS: <ClipboardList className='lucid-icon-common ' />,
  DESCRIPTION_WORKFLOW: <FileType2 className='lucid-icon-common ' />,
  CHART_LINE: <ChartColumnBig className='lucid-icon-common' />,
  TRIGGERED_TASKS: <ListTodo className='lucid-icon-common cursor-pointer' />,
  ATTACHMENT: <Paperclip className='lucid-icon-common cursor-pointer' />,
  TREE: <CircuitBoard className='lucid-icon-common cursor-pointer' />,
  MEDIATION: <Combine className='lucid-icon-common'  />,
  COMMENT: <MessageSquareText className='lucid-icon-common ' />,
  NEW_COMMENT: <MessageSquarePlus className='lucid-icon-common cursor-pointer' />,
  ACTIVITY_HISTORY: <History className='lucid-icon-common cursor-pointer' />,
  OPEN_IN_FULL: <Maximize2 className='lucid-icon-common cursor-pointer' />,
  ADD_CIRCLE: <CirclePlus className='lucid-icon-common cursor-pointer task-align' />,
  NORTH_EAST: <MoveUpRight className='lucid-icon-common cursor-pointer' />,
  SOUTH_WEST: <MoveDownLeft className='lucid-icon-common cursor-pointer' />,
  CHECKBOX: <Check className='lucid-icon-common cursor-pointer' />,
  SAVE_MARK: <Check className='lucid-icon-common cursor-pointer style' data-toggle='tooltip' data-placement='bottom' title='Save' />,
  SAVE: <FileDown className='lucid-icon-common cursor-pointer style ' data-toggle='tooltip' data-placement='bottom' />,
  CHECK: (
    <BadgeCheck
      className='lucid-icon-common cursor-pointer opacity-7'
      data-toggle='tooltip'
      data-placement='bottom'
      title='Mark As Complete'
    />
  ),
  CHECK_ICON: (
    <BadgeCheck className='lucid-icon-common cursor-pointer opacity-7' data-toggle='tooltip' data-placement='bottom' title='Task Status' />
  ),
  GREEN_OUTLINED_CHECK: (
    <BadgeCheck
      className='lucid-icon-common cursor-pointer opacity-7 green'
      data-toggle='tooltip'
      data-placement='bottom'
      title='Completed by team'
    />
  ),
  GREEN_CHECK: (
    <BadgeCheck
      className='lucid-icon-common green cursor-pointer material-symbols-fill'
      data-toggle='tooltip'
      data-placement='bottom'
      title='Task Completed'
    />
  ),
  CHANGE_SEARCH: (
    <ArrowRightLeft className='lucid-icon-common cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Change Search' />
  ),
  GREEN_CHECK_WORKFLOW: (
    <BadgeCheck className='lucid-icon-common green cursor-pointer' data-toggle='tooltip' data-placement='bottom' title='Final Stage' />
  ),
  OPEN_LOCK: <Users className='lucid-icon-common cursor-pointer blue material-symbols-fill filled-icon' />,
  SHARED_CONTENT: <Users className='lucid-icon-common cursor-pointer filled-icon' />,
  RECENT_CONTENT: <ClockAlert className='lucid-icon-common' />,
  PRIORITY_LOW: <i className='bi bi-chevron-down' title='Low'></i>,
  PRIORITY_MEDIUM: <i className='bi bi-pause fa-rotate-90 d-inline-block' title='Medium'></i>,
  PRIORITY_HIGH: <i className='bi bi-chevron-up' title='High'></i>,
  PRIORITY_HIGHEST: <i className='bi bi-chevron-double-up' title='Highest'></i>,
  ALL_TASKS_ICON: <ListCheck className='lucid-icon-common' />,
  SENT_BY_DELEGATION: <SquareArrowOutUpRight className='lucid-icon-common icon-equal-dimension' />,
  RECIEVED_BY_DELEGATION: <SquareArrowOutUpRight className='lucid-icon-common fa-rotate-90 d-inline-block icon-equal-dimension' />,
  SENT_BY_PASS_ON: <AppWindow className='lucid-icon-common icon-equal-dimension' />,
  RECIEVED_BY_PASS_ON: <AppWindow className='lucid-icon-common fa-rotate-180 d-inline-block red icon-equal-dimension' />,
  TASK_PERSON: <User className='lucid-icon-common cursor-pointer filled-icon' />,
  TRASH: <Trash2 className='lucid-icon-common cursor-pointer red' />,
  PROJECT_QUEUE_MOVE: <ArrowRightLeft className='lucid-icon-common cursor-pointer' />,
  USER_ICON: <User className='lucid-icon-common  filled-icon' />,
  TRIPLE_DOT: <Ellipsis className='lucid-icon-common cursor-pointer' />,
  ADD_REACTION: <SmilePlus className='lucid-icon-common ' />,
  SEND_BUTTON: <SendHorizontal data-atr='send button' className='lucid-icon-common ' />,
  CANCEL: <CircleX className='lucid-icon-common cursor-pointer' />,
  DATE_RANGE: <CalendarDays className='lucid-icon-common maroon-text' />,
  ARROW_RIGHT_WORKFLOW: <CornerDownRight className='lucid-icon-common cursor-pointer subdirectory-arrow-right' title='Incoming Stage' />,
  EDIT_ICON: <Pencil className='lucid-icon-common cursor-pointer' />,
  DELETE_ICON: <Trash2 className='lucid-icon-common' />,
  DELETE_FOREVER_ICON: <Trash className='lucid-icon-common' />,
  CHECK_CIRCLE_ICON: <CheckLine className='lucid-icon-common green' />,
  CANCEL_ICON: <CircleX className='lucid-icon-common cursor-pointer' />,
  REMOVE_ICON: <CircleMinus className='lucid-icon-common' />,
  CHECK_LIST_ICON: <ListChecks className='lucid-icon-common' />,
  ADD_CIRCLE_ICON: <CirclePlus className='lucid-icon-common' />,
  HIGHLIGHT_OFF_ICON: <CircleX className='lucid-icon-common cursor-pointer' />,
  ADD_NOTE: <Plus className='lucid-icon-common' />,
  CLOSE_EDITOR: <X className='lucid-icon-common' title='Close' />,
  ADD_BOOKMARK: <BookmarkPlus className='lucid-icon-common' />,
  BOOKMARK: <Bookmark className='lucid-icon-common' />,
  BOOKMARK_FILL: (color) => <Bookmark className='lucid-icon-common' fill={color} />,
  BOOKMARK_ADDED: <BookmarkCheck className='lucid-icon-common' />,
  SAVE_NOTE: <Save className='lucid-icon-common' />,
  BACK_HAND_OUTLINED: <Hand className='lucid-icon-common opacity-7' />,
  BACK_HAND: <Hand className='lucid-icon-common material-symbols-fill' />,
  WAVING_HAND: <Hand className='lucid-icon-common ' />,
  BACKWARD_ARROW: <Reply className='lucid-icon-common cursor-pointer' />,
  REPLY: <Reply className='lucid-icon-common fa-rotate-180 cursor-pointer' />,
  LINK: <Link2 className='lucid-icon-common blue' data-toggle='tooltip' data-placement='bottom' title='Share Link' />,
  SHARE: <Share2 className='lucid-icon-common' />,
  FORM_ICON: <FileText className='lucid-icon-common' />,
  BOOKMARK_STAGE: <Radar className='lucid-icon-common' />,
  BOOKMARK_NAME: <CheckLine className='lucid-icon-common' />,
  CHECK_NOTIFICATIONS: <CheckLine className='lucid-icon-common cursor-pointer' />,
  BELL_ICON: <BellRing className='lucid-icon-common ' />,
  RECENT_SEARCH: <SearchCheck className='lucid-icon-common' />,
  TAG: <Tag className='lucid-icon-common' />,
  PANEL: <Grid2x2 className='lucid-icon-common' />,
  DEFAULT_SETTINGS: <SlidersHorizontal className='lucid-icon-common' />,
  STAGES: <Server className='lucid-icon-common' />,
  RECUR: <Repeat className='lucid-icon-common' />,
  LOCK_ICON: <LockKeyhole className='lucid-icon-common material-symbols-fill ' />,
  LOCK_ICON_OPEN: <LockKeyholeOpen className='lucid-icon-common material-symbols-fill ' />,
  BELL: <BellRing className='lucid-icon-common' />,
  LOCK_TASK_ICON: <Lock className='lucid-icon-common material-symbols-fill filled-icon' />,
  ARCHIVE: <Archive className='lucid-icon-common' />,
  EDIT_DESCRIPTION: <Pencil className='lucid-icon-common cursor-pointer opacity-7' />,
  ATTACH_FILE: <Paperclip className='lucid-icon-common cursor-pointer' title='Attachment' />,
  SHARE_FILE: <Share2 className='lucid-icon-common' />,
  DELINK_TASK: <Link2Off className='lucid-icon-common' />,
  LINK_ATTACHMENT: <Link2 className='lucid-icon-common cursor-pointer' />,
  REMOVE: <Minus className='lucid-icon-common' />,
  LIST_VIEW: <SquareEqual className='lucid-icon-common' />,
  USER_PEN: <UserPen />,
  DASHBOARD_VIEW: <PanelsLeftBottom className='lucid-icon-common' />,
  TASK_FOLLOWERS: <Users className='lucid-icon-common cursor-pointer material-symbols-fill filled-icon' />,
  DESCRIPTION_POPUP_ICON: <SquareArrowOutUpRight className='lucid-icon-common' />,
  AUTO_SAVE: <RefreshCw className='lucid-icon-common' />,
  APPORVAL_APPROVED: <ShieldCheck className='lucid-icon-common approval-approved' />,
  APPROVAL_ICON: <ShieldCheck className='lucid-icon-common approval-initiated' />,
  APPROVAL_RECOMMENDED: <CircleArrowUp className='lucid-icon-common' />,
  APPROVAL_ONHOLD: <Hourglass className='lucid-icon-common' />,
  APPROVAL_REJECTED: <ShieldX className='lucid-icon-common approval-rejected' />,
  APPROVAL_REASSIGN: <MoveRight className='lucid-icon-common' />,
  APPROVAL_SKIP: <Redo className='lucid-icon-common' />,
  OPEN_IN_BROWSER: <AppWindow className='lucid-icon-common' />,
  DELETE_APPROVAL_LOGS: <Trash2 className='lucid-icon-common' />,
  APPROVAL_INFO: <Info className='lucid-icon-common' />,
  APPROVAL_REVOKE: <CircleOff className='lucid-icon-common' />,
  FOLLOWER_ICON: <CircleFadingPlus className='lucid-icon-common cursor-pointer' />,
  FILTER: <Funnel className='lucid-icon-common' />,
  FILTER_FILLED: <Funnel className='lucid-icon-common filled-icon' />,
  DO_NOT_DISTURB: <CircleMinus className='lucid-icon-common' />,
  DEFAULT_ICON: <FileCheck className='lucid-icon-common' />,
  FINANCE_TEAM: <Receipt className='lucid-icon-common' />,
  EDIT_WORKSPACE: <Pencil className='lucid-icon-common cursor-pointer opacity-7' title='Edit Workspace' />,
  TASK: <FileCheck className='lucid-icon-common' />,
  IMAGE: <Image className='lucid-icon-common' />,
  NO_ASSIGNEE: <UserMinus className='lucid-icon-common' />,
  CLEAR_ALL: <ChartNoAxesGantt className='lucid-icon-common' />,
  ADD: <Plus className='lucid-icon-common' />,
  DONE_OUTLINED: <CheckLine className='lucid-icon-common green' />,
  INFO_ICON: <Info className='lucid-icon-common' />,
  BOOKMARK_FAVORITE: <Star className='lucid-icon-common favorite-remove-color' />,
  FAVORITE: <Star className='lucid-icon-common filled-icon favorite-color' />,
  MARK_FAVORITE: <Star className='lucid-icon-common favorite-remove-color' />,
  BOOKMARK_MARK_FAVORITE: <Star className='lucid-icon-common material-symbols-fill favorite-color filled-icon' />,
  RADIO_BUTTON_CHECKED: <CircleStop className='lucid-icon-common' />,
  FLAG: <Flag className='lucid-icon-common' />,
  ARROW_LEFT: <MoveLeft className='lucid-icon-common' />,
  ARROW_RIGHT: <MoveRight className='lucid-icon-common' />,
  ARROW_FORWARD: <ArrowRight className='lucid-icon-common' />,
  ARROW_BACK_IOS: <ChevronLeft className='lucid-icon-common' />,
  ARROW_UP: <ChevronUp className='lucid-icon-common' />,
  ARROW_DOWN: <ChevronDown className='lucid-icon-common' />,
  ADD_TASK: <CircleCheckBig className='lucid-icon-common' />,
  FILE_UPLOAD: <Upload className='lucid-icon-common' />,
  FILE_UPLOADING: <ArrowDown className='lucid-icon-common fa-rotate-180' />,
  UNFOLD_MORE: <ChevronsUpDown className='lucid-icon-common' />,
  DOWNLOAD_FILE: <CloudDownload className='lucid-icon-common' />,
  UNLOCK: <LockKeyholeOpen className='lucid-icon-common' />,
  EDIT_RULE: <Pencil className='lucid-icon-common cursor-pointer opacity-7' title='Edit Rule' />,
  APPROVAL_LOCK: <Lock className='lucid-icon-common cursor-pointer material-symbols-fill ' />,
  MINIMIZE: <Minus className='lucid-icon-common' />,
  OPEN_IN_NEW: <SquareArrowOutUpRight className='lucid-icon-common' style={{ height: "24px", width: "24px" }} />,
  DRAG_HANDLE: <GripVertical className='lucid-icon-common  filled-icon' />,
  DEACTIVATE_USER: <UserMinus className='lucid-icon-common' />,
  REACTIVATE_USER: <User className='lucid-icon-common  filled-icon' />,
  ADMIN_ACTIVITY_LOG: <History className='lucid-icon-common' />,
  BOLT: <Snowflake className='lucid-icon-common' />,
  QUICK_FILTER_ONE: <Loader className='lucid-icon-common' />,
  QUICK_FILTER_TWO: <ScrollText className='lucid-icon-common' />,
  QUICK_FILTER_THREE: <Grip className='lucid-icon-common' />,
  QUICK_FILTER_FOUR: <GalleryHorizontalEnd className='lucid-icon-common' />,
  COPY_CONTENT: <Copy className='lucid-icon-common ' />,
  PLAN_DO_LATER: <CalendarCheck2 className='lucid-icon-common' />,
  PLAN_SKIP_TASKS: <CalendarX className='lucid-icon-common' />,
  PLAN_DO_TODAY: <CalendarCheck className='lucid-icon-common' />,
  PLAN_DO_TOMORROW: <CalendarDays className='lucid-icon-common' />,
  PLAN_CUSTOM_DUE_DATE: <CreditCard className='lucid-icon-common' />,
  PLAN_REMIND_TOMORROW: <Bell className='lucid-icon-common cursor-pointer' />,
  PLAN_CUSTOM_REMIND: <BellPlus className='lucid-icon-common' />,
  LOCATION: <LocateFixed className='lucid-icon-common live-location-icon' />,
  PHOTO_CAMERA: <Camera className='lucid-icon-common' />,
  ROLE: <User className='lucid-icon-common  filled-icon' />,
  KEYBOARD_HIDE: <FilePen className='lucid-icon-common' />,
  KEYBOARD_LOCK: <FileLock className='lucid-icon-common' />,
  KEYBOARD_LOCK_OFF: <FileSpreadsheet className='lucid-icon-common' />,
  WARNING: <TriangleAlert className='lucid-icon-common' />,
  QUICK_TOUR: <PlaneTakeoff className='lucid-icon-common' />,
  FORM_ADD: <ClipboardList className='lucid-icon-common' />,
  ADD_OFFICE_LOCATION:<MapPin className='lucid-icon-common' />,
  ARROW_DROP_DOWN: <ChevronDown className='lucid-icon-common ' />,
  LIST: <List className='lucid-icon-common' />,
  CHART_WIDGET_OPEN: <PanelTopOpen className='lucid-icon-common' />,
  CHART_WIDGET_DELEGATED: <Mails className='lucid-icon-common' />,
  CHART_WIDGET_OVEDUE: <KeyRound className='lucid-icon-common' />,
  CHART_WIDGET_COMPLETED: <ClipboardCheck className='lucid-icon-common' />,
  FORM_1: <ClipboardCheck className='lucid-icon-common' />,
  WORKFLOW_1: <ClipboardCheck className='lucid-icon-common' />,
  WORKFLOW_2: <BookUser className='lucid-icon-common' />,
  WORKFLOW_3: <List className='lucid-icon-common' />,
  WORKFLOW_4: <ClipboardList className='lucid-icon-common' />,
  WORKFLOW_5: <CircleCheckBig className='lucid-icon-common' />,
  WORKFLOW_6: <IndianRupee className='lucid-icon-common' />,
  WORKFLOW_7: <NotepadText className='lucid-icon-common' />,
  WORKFLOW_8: <CircleGauge className='lucid-icon-common' />,
  WORKFLOW_9: <Bell className='lucid-icon-common' />,
  WORKFLOW_10: <Package className='lucid-icon-common' />,
  WORKFLOW_11: <SquaresExclude className='lucid-icon-common ' />,
  WORKFLOW_12: <Trophy className='lucid-icon-common' />,
  WORKFLOW_13: <ListStart className='lucid-icon-common' />,
  WORKFLOW_14: <Gift className='lucid-icon-common' />,
  WORKFLOW_15: <Crosshair className='lucid-icon-common' />,
  WORKFLOW_16: <CalendarCheck className='lucid-icon-common' />,
  WORKFLOW_17: <CalendarCheck2 className='lucid-icon-common' />,
  WORKFLOW_18: <Target className='lucid-icon-common' />,
  WORKFLOW_19: <LaptopMinimalCheck className='lucid-icon-common' />,
  WORKFLOW_20: <CircleQuestionMark className='lucid-icon-common' />,
  WORKFLOW_21: <Inbox className='lucid-icon-common' />,
  WORKFLOW_22: <ShieldCheck className='lucid-icon-common' />,
  WORKFLOW_23: <Wrench className='lucid-icon-common' />,
  WORKFLOW_24: <ThumbsUp className='lucid-icon-common' />,
  WORKFLOW_25: <SquarePen className='lucid-icon-common' />,
  WORKFLOW_26: <BookOpenText className='lucid-icon-common' />,
  WORKFLOW_27: <Box className='lucid-icon-common' />,
  WORKFLOW_28: <ClipboardType className='lucid-icon-common' />,
  WORKFLOW_29: <Settings className='lucid-icon-common' />,
  WORKFLOW_30: <Rocket className='lucid-icon-common' />,
  WORKFLOW_31: <ShoppingCart className='lucid-icon-common' />,
  WORKFLOW_32: <Smartphone className='lucid-icon-common' />,
  WORKFLOW_33: <FileChartLine className='lucid-icon-common' />,
  WORKFLOW_34: <BookText className='lucid-icon-common' />,
  WORKFLOW_35: <Banknote className='lucid-icon-common' />,
  WORKFLOW_36: <LayoutDashboard className='lucid-icon-common' />,
  WORKFLOW_37: <WalletCards className='lucid-icon-common' />,
  WORKFLOW_38: <SquareArrowDown className='lucid-icon-common' />,
  WORKFLOW_39: <MapPin className='lucid-icon-common' />,
  WORKFLOW_40: <AlarmClock className='lucid-icon-common' />,
  WORKFLOW_41: <CopyCheck className='lucid-icon-common' />,
  WORKFLOW_42: <ChartColumnIncreasing className='lucid-icon-common' />,
  WORKFLOW_43: <PictureInPicture2 className='lucid-icon-common' />,
  WORKFLOW_44: <Globe className='lucid-icon-common' />,
  WORKFLOW_45: <MessageSquare className='lucid-icon-common' />,
  WORKFLOW_46: <Folders className='lucid-icon-common' />,
  WORKFLOW_47: <Bot className='lucid-icon-common' />,
  WORKFLOW_48: <CircleEllipsis className='lucid-icon-common' />,
  WORKFLOW_49: <CalendarRange className='lucid-icon-common' />,
  WORKFLOW_50: <FileUser className='lucid-icon-common' />,
  WORKFLOW_51: <Bug className='lucid-icon-common' />,
  WORKFLOW_52: <StickyNote className='lucid-icon-common' />,
  WORKFLOW_53: <Plane className='lucid-icon-common' />,
  WORKFLOW_54: <RefreshCw className='lucid-icon-common' />,
  WORKFLOW_55: <FileSearch className='lucid-icon-common' />,
  WORKFLOW_56: <CircleDollarSign className='lucid-icon-common' />,
  WORKFLOW_57: <IdCard className='lucid-icon-common' />,
  WORKFLOW_58: <ShieldPlus className='lucid-icon-common' />,
  WORKFLOW_59: <ContactRound className='lucid-icon-common' />,
  WORKFLOW_60: <Laptop className='lucid-icon-common' />,
  WORKFLOW_61: <CopyCheck className='lucid-icon-common' />,
  WORKFLOW_62: <ShoppingBag className='lucid-icon-common' />,
  WORKFLOW_63: <Webhook className='lucid-icon-common' />,
  WORKFLOW_64: <Image className='lucid-icon-common' />,
  WORKFLOW_65: <CalendarPlus className='lucid-icon-common' />,
  EDITOR_CANVAS: <PenLine className='lucid-icon-common' />,
  IFRAME: <Dock className='lucid-icon-common' />,
  PICTURE_AS_PDF: <FileDown className='lucid-icon-common' />,
  INSERT_IMAGE_EDITOR: <ImagePlus className='lucid-icon-common' />,
  SYNC: <RefreshCw className='lucid-icon-common' />,
  WORK: <Briefcase className='lucid-icon-common' />,
  ARROW_BACK: <ArrowLeft className='lucid-icon-common' />,
  LIBRARY: <BookCheck className='lucid-icon-common' />,
  SAVE_SNAPSHOT: <CloudSync className='lucid-icon-common' />,
  RESTORE_SNAPSHOT: <RotateCcw className='lucid-icon-common' />,
  LOCATION: <LocateFixed className='lucid-icon-common' />,
  DEPARTMENT: <FolderOutput className='lucid-icon-common' />,
  BOOKMARK_TOOL: <BookmarkCheck className='lucid-icon-common' />,
  FOLDER: <Folder className='lucid-icon-common' />,
  TASK_ESCALATION: <ChevronsUp className='lucid-icon-common' />,
  COST_CENTER: <Receipt className='lucid-icon-common' />,
  BUSINESS_UNIT: <Landmark className='lucid-icon-common' />,
  MORE: <EllipsisVertical className='lucid-icon-common' />,
  REFRESH: <RotateCcw className='lucid-icon-common' />,
  CMS_RESTORE: <RotateCcw className='lucid-icon-common' />,
  GROUP_REMOVE: <UserMinus className='lucid-icon-common' />,
  API_ACTIVE: <Webhook className='lucid-icon-common' />,
  ARROW_DROPDOWN_ICON: <ChevronDown className='lucid-icon-common filled-icon' />,
  PHONE: <Phone className='lucid-icon-common' />,
  SMARTPHONE: <Smartphone className='lucid-icon-common' />,
  MAIL: <Mail className='lucid-icon-common' />,
  APPROVAL: <ShieldCheck className='lucid-icon-common' />,
  PLAN_MY_DAY: <CalendarCheck2 className='lucid-icon-common' />,
  ASSIGNED: <ClipboardList className='lucid-icon-common' />,
  STREAMS: <Podcast className='lucid-icon-common' />,
  REFRESH: <RefreshCw className='lucid-icon-common' />,
  MAXIMIZE: <SquareArrowOutUpRight className='lucid-icon-common' />,
  CLOUD_UPLOAD: <CloudUpload className='lucid-icon-common' />,
  LIST_ICON: <ListIcon class='lucid-icon-common' />,
  COLUMNS3: <Columns3 className='lucid-icon-common' />,
  ROTATE_CCW: <RotateCcw className='lucid-icon-common' />,
  SHARE2: <Share2 className='lucid-icon-common' />,
  PLUS: <Plus className='lucid-icon-common' />,
  CIRCLEPLUS: <CirclePlus className='lucid-icon-common' />,
  CIRCLE_STAR: <Sparkles className='lucid-icon-common' />,
  DISABLED: <ClipboardX className='lucid-icon-common' />,
  SMILE_PLUSH: <SmilePlus className='lucid-icon-common' />,
  REPLY: <Reply className='lucid-icon-common' />,
  SEND_HORIZONTAL: <SendHorizontal className='lucid-icon-common' />,
  USER_CHECK : <UserCheck className='lucid-icon-common' />,
  IMAGE_UP: <ImageUp className='lucid-icon-common' />,
  PIN: <Pin className='lucid-icon-common' />,
  CIRCLE_CHECK_GREEN: <CircleCheck  className='lucid-icon-common icon-green'  />,
  PIN_OFF: <PinOff className='lucid-icon-common' />,
  BADGE_QUESTION_MARK: <BadgeQuestionMark className='lucid-icon-common' />,
  VOLUME2: <Volume2 className='lucid-icon-common' />,
  PAPER_CLIP: <Paperclip className='lucid-icon-common' />,
  CIRCUIT_BOARD: <CircuitBoard className='lucid-icon-common' />,
  BETWEEN_HORIZONTAL_END: <BetweenHorizontalEnd className='lucid-icon-common' />,
  CLOCK_FADING: <ClockFading className='lucid-icon-common' />,
  VIEW_CONTROL: <LayoutList className='lucid-icon-common' />,
  HAND: <Hand className='lucid-icon-common' />,
  BOLD: <Bold className='lucid-icon-common' />,
  LIST_ORDERED: <ListOrdered className='lucid-icon-common' />,
  WORKFLOW_ELEMENTS: <Workflow className='lucid-icon-common' />,
  REFRESH_CC_DOT: <RefreshCcwDot className='lucid-icon-common' />,
  TRIANGLE_ALERT: <TriangleAlert className='lucid-icon-common' />,
  INFO: <Info className='lucid-icon-common' />,
  CIRCLE_CHECK: <CircleCheck className='lucid-icon-common' />,
  CIRCLE_ALERT: <CircleAlert className='lucid-icon-common' />,
  BAN: <Ban className='lucid-icon-common' />,
  USER_MINUS: <UserMinus className='lucid-icon-common' />,
  KEY_ROUND: <KeyRound className='lucid-icon-common' />,
  SQUARE_KANBAN: <SquareKanban className='lucid-icon-common' />,
  BOOK_OPEN_TEXT: <BookOpenText className='lucid-icon-common' />,
  TAG_ICON: <Tag className='lucid-icon-common' />,
  ADD_GROUP: <Users className='lucid-icon-common icon-blue' />,
  FILE_QUESTION_MARK: <FileQuestionMark className='lucid-icon-common' />,
  KEY_SQUARE: <KeySquare className='lucid-icon-common' />,
  USER_LOCK: <UserLock className='lucid-icon-common' />,
  BELL_DOT: <BellDot className='lucid-icon-common' />,
  ArrowDown01: <ArrowDown01 className='lucid-icon-common' />,
};

export const directory = {
  ORGANIZATION: "Organization",
  USER_PROFILE: "User_Profile",
  ATTACHMENT: "Task_Attachment",
};

/** `:uId` values for project workflow sections */
export const WORKFLOW_SECTION_SLUGS = ["overview", "teams", "workflows", "forms", "automation"];

export const link = {
  HELP_SUPPORT: "https://drutas.com/help/",
  DRUTAS_HOME: "https://drutas.com/",
  TASK_CODE_HELP: "https://drutas.com/help/tasks/how-to-create-a-task/what-is-a-task-code/",
  QUEUE_HELP_BOOKMARK: "https://drutas.com/help/workspaces/",
  PROJECT_HELP_BOOKMARK: "https://drutas.com/help/teams/",
  TASK_HELP_BOOKMARK: "https://drutas.com/help/tasks/",
  ARCHIVE_HELP_BOOKMARK: "https://drutas.com/help/teams/",
  UNDER_CONSTRUTION_IMG: "https://www.processmaker.com/wp-content/uploads/2021/08/business-process-automation-use-cases-768x512.jpg",
  IMAGE_SAVE_URL: "https://demos.telerik.com/kendo-ui/service-v4/upload/save",
  IMAGE_REMOVE_URL: "https://demos.telerik.com/kendo-ui/service-v4/upload/remove",
  VERSION_URL: "https://drutas.com/updates/",
  WORKFLOW_HELP_SUPPORT: "https://drutas.com/help/automation-using-workflows/",
  PRIVACY_POLICY: "https://drutas.com/privacy-policy/",
  HELP: "https://drutas.com/help/login-and-setup/",
  ADD_TASK: "https://drutas.com/help/tasks/",
  TEAM_NAME: "https://drutas.com/help/tasks/",
  COMMENT: "https://drutas.com/help/tasks/comments-in-the-task-sidebar/",
  TASK_ESCALATION_HELP: "https://drutas.com/help/application-features/task-escalation/",
};

export const tooltip = {
  EDITABLE_BY_CURRENT_TEAM_MEMBERS_ONLY: "Editable by current team members only",
  EDIT_REVIEW: "Edit Review",
  /** Tooltip when form edit is restricted to team managers; (name) is the team/operational name. */
  EDITABLE_BY_MANAGERS_ONLY: (name) => `Editable by ${name} Managers only`,
  EDIT_FORM: "Edit Form",
  TIME: "Time",
  DETAILS: "Details",
  USER_NAME: "User Name",
  ACTION: "Action",
  CHOOSE_PROJECT_COLOR: "Choose Team Color",
  PROJECT_NAME: "Project Name",
  PROJECT_CODE: "Project Code",
  TEAM: "Workspace",
  END_DATE: "End Date",
  MEMBERS: "Members",
  TASKS: "Tasks",
  LAST_ACTIVITY: "Last Activity",
  ADD_QUEUE_ADMIN_ACCESS: "For adding a Workspace, Admin access is required",
  PROJECTS: "Projects",
  OWNERS: "Owners",
  HELP: "Help",
  USER: "User",
  FLAG: "Flag",
  UNFLAG: "Unflag",
  PROJECT: "Projects",
  INSERT_IMG: "Insert Image",
  UPLOAD: "Upload",
  EDIT: "Edit",
  ACKNOWLEDGE_NUDGE: "Acknowledge Nudge",
  ACK: "Ack",
  ACK_SEND_AHEAD: "Ack & Send Ahead",
  USER_NUDGED: "User Nudged",
  NUDGE_NEXT_ASSIGNEE: "Nudge the Next Assignee",
  TASK_ID: "Task Id",
  DUE_DATE: "Due Date",
  DUE: "Due",
  PRIORITY: "Priority",
  ASSIGNEE_FILTER_PLACEHOLDER: "All Assignee",
  ASSIGNEE: "Assignee",
  STAGE: "Stage",
  TAGS: "Tags",
  TASK: "Task",
  PROJECT_RULES: "Project Rules",
  BASIC_DETAILS: "Basic Details",
  DISCARD: "Discard",
  CANCEL: "Cancel",
  ADD: "Add",
  UPDATE: "Update",
  DELETE: "Delete",
  DELETE_FILTER: "Delete Filter",
  CLEAR_ASSIGNEE: "Clear Assignee",
  NAME: "Name",
  STAGE_NAME: "Stage Name",
  ADD_NEW: "Add new",
  NOTES: "Notes",
  NOTIFICATIONS: "Notifications",
  REMINDER: "Reminder",
  REMINDER_DUE: "Reminder due",
  CLICK_TO_DISABLE: "Click to Disable",
  CLICK_TO_ENABLE: "Click to Enable",
  FONT_COLOR: "Font color",
  OPEN_TASK: "Open Task",
  OPEN_TASK_TITLE: "Open in new tab",
  LINK_THIS_TASK: "Link This Task",
  COPY_TASK_LINK: "Copy Task Link",
  REMOVE_LINK: "Remove Link",
  EDIT_LINK: "Edit Link",
  SELECT_DATE_TOOLTIP: "Select Date",
  SELECT_TIME_TOOLTIP: "Select Time",
  ADD_BOOKMARK_TOOLTIP: "Add Bookmark",
  TEXT_BACKGROUND_COLOR: "Text background color",
  SEND_COMMENT: "Send Now ",
  DELETE_APPROVAL: "Delete Approval Request",
  ADD_NOTE: "Add note",
  VIEW_NOTE: "View note",
  REVOKE_APPROVAL: "Revoke approval",
  ADD_TASK_CTRLD: "Add Task... (Ctrl + D)",
  ADD_REMINDER: "Add Reminder",
  DEFAULT_ASSIGNEE: "Default Assignee",
  DEFAULT_WORKFLOW: "Default Workflow",
  PRIVACY: "Privacy",
  CURRENT_STAGE_SKIP: "Skipping not allowed on task current stage",
  ADD_FILTER: "Add Filter",
  DELETE_FILTER: "Delete",
  EDIT_FILTER: "Edit Filter",
  EXIT: "Exit",
  SKIP_STAGE: "Skip stage",
  STAGE_SKIPPED: "Stage is skipped",
  TAGS_OR_DESC: "OR",
  TAGS_AND_DESC: "AND",
  SELECT_TEAM: "Select Team(s)",
  MOVE_TEAM: "Move Team(s)",
  MINIMIZE: "Minimize",
  CLONE: "Clone",
  WORKFLOW_DELETE_ACCESS: "you don't have access to delete this workflow",
  WORKFLOW_DEFAULT: "A default worfklow can't be deleted",
  WORKFLOW_USAGE: "The Workflow is currently in use , Click for Details",
  UNLOCK_TASK: "Unlock Task",
  LOCK_TASK: "Lock Task",
  SEEK_APPROVAL: "Seek Approval",
  LOCKED_ON_COMPLETION: "Locked on completion",
  CLICK_TO_ASSIGN: "Click To Assign",
  ADD_REACTION: "Add Reaction",
  REMOVE_FOLLOWER: "Remove Follower",
  FLOW: "Flow",
  MOVE: "Move",
  NEXT: "Next",
  PREVIOUS: "Previous",
  OPEN_DESCRIPTION: "Open Description",
  REMOVE_ATTACHMENT: "Remove attachment",
  EDIT_ATTACHMENT: "Edit attachment",
  DOWNLOAD_ATTACHMENT: "Download attachment",
  DELINK_TASK: "Delink task",
  ACTIONS: "Actions",
  UPLOAD_AN_IMAGE: "Upload an image",
  APPROVAL: "Approval",
  COMMENTS: "Comments",
  COPY_WORKFLOW_LINK: "Copy workflow link",
  DELETE_WORKFLOW: "Delete Workflow",
  PLAN_COMPLETE: "Completed",
  PLAN_TODAY: "Do today",
  PLAN_DO_LATER: "Do later",
  PLAN_REMINDER: "Remind me",
  PLAN_SKIP: "Skip",
  PLAN_CLOSE: "Close plan my day",
  TASK_CODE: "A unique code for easy tracking of your tickets.",
  COPY_EMAIL: "Copy Email",
  ADD_NEW_EMAIL: "Add new Email Id",
  SUPPORT_CENTER: "Support Center",
  SYSTEM_STREAMS: "System Streams",
  VIEW_BY_POPULARITY: "View by popularity",
  VIEW_RECENT_WORKFLOWS: "View recent workflows",
  VIEW_CLASSIC_COLLAB_CENTRAL: "View Classic Collab Central",
  MAIL: "Mail",
  SPAM: "Spam",
  FILE_NAME: "File Name",
  UPLOADED_DATE: "Uploaded Date",
  UPLOADED_BY: "Uploaded By",
  SIZE: "Size",
  ACTION: "Action",
  MANAGE_PROJECT: "Project",
  DELETE_EMAIL: "Delete Email",
  MARK_AS_SPAM: "Mark as spam",
  MARKED_AS_SPAM: "Marked as spam",
  CREATED_AT: "Data for the past 7 days",
  TOTAL_WORKFLOWS: "Workflows",
  TOTAL_PROJECTS: "Teams",
  APPROVAL_INITIATED: "Initiated",
  APPROVAL_GRANTED: "Granted",
  SAVE_FILTER: "Save Filter",
  CREATED: "Created",
  COMPLETED: "Completed",
  REMARK: "Remark",
  ENABLE: "Enable",
  DISABLE: "Disable",
  EDIT_VERSION_NAME: "Edit version name",
  REMARKS: "Remarks",
  ASSOCIATED_PROJECTS: "Associated Projects",
  ACTIVE_USERS: "Active Users",
  ACTIVE_EMPLOYEES: "Active Employees",
  COUNT: "Count",
  USER_COUNTS: "User Counts",
  DELETE_API: "Delete API",
  REGENERATE_API_KEY: "Regenerate API Key",
  COPY_API_KEY: "Copy API Key",
  TRY_IT: "Try it",
  NEW_BLOCK_ASSIGNEMENT: "Add New Block",
  NOTIFICATION_TYPE: "Notification Type",
  MARK_AS_READ: "Mark As Read",
  DRAWING: "Drawing",
  ADD_A_FOLDER: "Add a folder",
  ADD_NEW_DOCUMENT: "Add a new Document",
  ALIGN: "Align",
  SUBSCRIPT: "Subscript",
  TEXT_COLOR: "Text Color",
  HIGHLIGHT_COLOR: "Highlight Color",
  ADD_TO_FAVORITES: "Add to Favorites",
  MISSING_AUDIENCE_GROUP_AND_VALID_TRIGGERS: "Missing audience and triggers",
  MISSING_AUDIENCE_GROUP: "Missing Audience",
  MISSING_VALID_TRIGGERS: "Missing triggers",
  MISSING_WORKFLOWS_AND_FORMS: "Missing Workflows and Forms",
  MISSING_FORMS: "Missing Forms",
  MISSING_WORKFLOWS: "Missing Workflows",
  VIEW_ACTIVITY_LOGS: "View Activity Logs",
  CUSTOM_STATUS: "Custom Status",
  SKIP_FOR_FORMS: "Skip for forms",
  SKIP_FOR_DESCRIPTION: "Skip for description",
  SKIP_FOR_FORMS_AND_DESCRIPTION: "Skip for forms and description",
  CLOSE: "Close",
  COPY: "Copy",
  DELETE_CHIP: "Delete Chip",
  CLICK_TO_ASSIGN: "Click to Assign",
};

export const dateFormat = {
  DATE_FORMAT: "h:mmaaa, dd MMM yy",
  LAST_ACTIVITY: "HH:mm, dd MMM yy",
  DEFAULT_DATE_FORMAT: "dd-MMM-yyyy",
  COMMON_DATE_FORMAT: "dd MMM yy",
  TODAY_DATE_FORMAT: "h:mm a",
  MONTH_DATE_FORMAT: "MMM d",
  DASHBOARD_FORMAT: "HH:mm, dd/MM/yyyy",
  DATE_FORMAT_WITHOUT_YEAR: "dd MMM",
  REMINDER_TIME_FORMAT: "HH:mm",
  REMINDER_DATE_FORMAT: "yyyy-MM-dd",
  /** Parse variable / sheet date strings stored as day/month/year with slashes (not US mm/dd). */
  SLASH_DD_MM_DATE_PARSE_FORMAT: "d/M/yyyy",
  EMAIL_GRID_DATE_FORMAT: "EEE, MMM d, h:mm a",
  CONTENT_ATTACHMENT_DATE_FORMAT: "dd MMM yy, h:mm a",
  JOIN_REQUEST_DATE_FORMAT: "d MMM, yyyy (h:mm aaa)",
  API_INTEGRATION_DATE_FORMAT: "dd MMM yyyy",
  FORM_DATE_FORMAT: "dd MMM yy (h:mm aaa)",
  SLASH_DD_MM_DATE_FORMAT: "dd/MM/yyyy",
};

export const replyBubbleConfig = {
  NONE: "none",
};

export const defaultColor = "#F2c9fb";

export const editorColors = ["#Dfedd6", "#C9f1fd", "#F2c9fb", "#Fff1d7", "#Fefac0"];

export const addOpenCase = {
  FROM_CLOSE_BUTTON: "fromCloseButton",
  FROM_OTHER_BUTTONS: "fromOtherButtons",
};

export const richEditor = {
  MODULES: {
    toolbar: [
      [{ size: [] }],
      [{ align: [] }],
      ["bold", "italic", "underline", "strike"],
      [
        {
          color: [
            "#000000", // Black
            "#e60000", // Red
            "#ff9900", // orange
            "#ffff00", // yellow
            "#008a00", // green
            "#0066cc", // Navy Blue
            "#9933ff", // Blue Violet
            "#ffffff", // White
            "#facccc", // light pink
            "#ffebcc", // Blanched Almond
            "#ffffcc", // Cream
            "#cce8cc", // Granny Apple
            "#cce0f5", //  Pattens Blue
            "#ebd6ff", // Blue Chalk
            "#bbbbbb", // Silver
            "#f06666", // Bittersweet
            "#ffc266", // Grandis
            "#ffff66", // Laser Lemon
            "#66b966", // Fern
            "#66a3e0", // Picton Blue
            "#c285ff", // Heliotrope
            "#888888", // Grey
            "#a10000", // Dark Red
            "#b26b00", // Dark Goldenrod
            "#b2b200", // La Rioja
            "#006100", // Dark Green
            "#0047b2", // Cobalt
            "#6b24b2", // Purple Heart
            "#444444", // Charcoal
            "#5c0000", // Maroon
            "#663d00", // Brown
            "#666600", // Olive
            "#003700", // Myrtle
            "#002966", // Sapphire
            "#3d1466", // Christalle
          ],
        },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [{ indent: "-1" }, { indent: "+1" }],
    ],
  },

  FORMATS: ["size", "align", "indent", "bold", "italic", "underline", "strike", "list", "bullet", "link", "image", "color"],
};

export const RESPONSIVE_WIDTH = 992;

export const placeholder = {
  WRITE_A_BRIEF_DESCRIPTION: "Write a brief description",
  ENTER_TASK_NAME: "Enter task name",
  SEARCH_NOTES: "Search Notes",
  WRITE_SOMETHING: "Write Something...",
  ENTER_COMPANY_NAME: "Enter your company name",
  SEARCH_BY_ORGANIZATION: "Search by organisation...",
  SELECTED_FIELDS: "Select Fields",
  SEARCH: "Search...",
  SEARCH_USER: "Search User...",
  SEARCH_PROJECT: "Search Project...",
  SEARCH_POPULAR_WORKFLOWS: "Search in popular workflows...",
  SEARCH_RECENT_WORKFLOWS: "Search in recent workflows...",
  REMINDER_TITLE: "Title",
  SAVE_TASK: "Save task. (Ctrl + S)",
  SELECT_FEATURE: "Search Features...",
  SEARCH_COMPANY: "Search Company...",
  SEARCH_SETTINGS: "Search Settings...",
  SEARCH_GROUP: "Search Group...",
  SEARCH_AUDIENCE: "Search Audience...",
  SELECT_AUDIENCE: "Select Audience",
  ENTER_GROUP_NAME: "Enter group name",
  ENTER_DESCRIPTION: "Enter description",
  SEARCH_MEMBERS: "Search members",
  SEARCH_MEMBERS_TO_ADD: "Search members to add",
  SELECT_MEMBERS: "Select members",
  ENTER_EMAIL: "Enter your email",
  ENTER_EMAIL_OR_NUMBER: "Enter your email/ Phone Number",
  ENTER_NUMBER: "Enter your Phone Number",
  ENTER_PHONE_NUMBER: "Enter your phone number",
  TRIGGER_NAME: "Trigger Name",
  SCHEDULE_NAME: "Schedule Name",
  LOADING_WORKFLOWS: "Loading workflows...",
  LOADING_RECURRENCE: "Loading recurrence options...",
  LOADING_CALENDAR: "Loading calendar...",
  SELECT_WORKFLOW: "Select Workflow",
  ENTER_AUTOMATION_NAME: "Enter automation name",
  QUICK_INFO: "Enter quick info about this automation",
  SELECT_USERS: "Select users",
  SEARCH_USERS: "Search users",
  SELECT_SEARCH_FIELDS: "Select Search Fields",
  ENTER_WORKSPACE_NAME: "Enter Space Name",
};

export const kendo = {
  INPUT_MIN_LENGTH: 0,
  INPUT_MAX_LENGTH: 35,
  TEAM_NAME_MAX_LENGTH: 120,
  TASK_INPUT_LENGTH: 120,
  INPUT_SECONDARY_LENGTH: 120,
};

export const notifyIcon = {
  ERROR_ICON: "error",
  SUCCESS_ICON: "success",
  WARNING_ICON: "warning",
};

/**
 * color palette settings.
 */
export const paletteSettings = {
  palette: "metro",
  tileSize: 16,
  palette: "basic",
};

/**
 * language settings.
 */
export const languages = {
  ENGLISH: "en",
};

/** no access object if user doesn't have access of queue */
export const noAccessObject = {
  access: number.ZERO,
};

export const errorCode = {
  CANCEL_REQUEST: "ERR_CANCELED",
};

export const REMINDER_DUE_DATE_OPTIONS = {
  day: "2-digit",
  month: "short",
  year: "numeric",
};

export const text = {
  TEXT: "text",
  REGISTERED: "registered",
  OPERATIONAL_TEAM_DROPDOWN: "operationalTeamDropDown",
  INDUSTRY_NAME: "industryName",
  OPERATIONAL_TEAM: "operationalTeam",
  TIMEZONE: "Timezone",
  INDUSTRY: "Industry",
  ORGANIZATION: "organization",
  USER_ID: "User Id",
  SSO_LOGIN: "SSO Login",
  CSV: "csv",
  PDF: "pdf",
  EXCEL: "excel",
  EXPORT_AS_TASK: "export as task",
  WELCOME_COMMA: "Welcome,",
};

export const regex = {
  REGISTER_NAME_REGEX: /^[a-zA-Z0-9-.]*$/,
};
export const quickFilters = {
  ALL_TASK: "All Task",
  OWNERSHIP: "Ownership",
  DELEGATED: "Delegated",
  ARCHIVED: "Archived",
  ASSIGNED: "Assigned",
  PENDING_APPROVALS: "Pending Approvals",
};

export const linkedTaskTypes = {
  CHILD_TASKS: "CHILD_TASKS",
  PARENT_TASKS: "PARENT_TASKS",
  RELATED_TASKS: "RELATED_TASKS",
};

export const attachmentSize = {
  ADMIN_CHATBOT_ATTACHMENT_LIMIT: 10485760, //10 * 1024 * 1024 (10 MB)
};

export const storageKeys = {
  ROLE_CARDS_EXPANDED: "jobRoles_cards_expanded",
  JOB_ROLES_SORT_SETTING: "jobRoles_sort_setting",
};
